import * as _ from "lodash"
import {IBusinessObject} from "../PA.Core/PA.Core.IF.BO"
import {IDateRange, IMessageProvider, IProgressProvider, MessageType} from "../PA.Core/PA.Core.IF.Basic"
import {PAdbContext} from "../PA.Core/PAdbContext"
import {IdentityProvider} from "../PA.Core/Basic/Identity"
import {MessageProvider} from "../PA.Core/Basic/Messages"
import {ProgressProvider} from "../PA.Core/Basic/Progress"
import {
    WB_AffinityGroupItemRow,
    WB_AffinityGroupRow,
    WB_AffinitySetRow,
    WB_AuditLogRow,
    WB_CustomerRow,
    WB_DomainItemRow,
    WB_DomainRow,
    WB_EntityRow,
    WB_FinishedProductRelationshipRow,
    WB_FinishedProductRow,
    WB_ModelCannibalizationRelationshipRow,
    WB_ModelCannibalizationTypeRow,
    WB_ModelCoefficientRow,
    WB_ModelDataSourceRow,
    WB_ModelingSessionASRRow,
    WB_ModelingSessionCannMRRow,
    WB_ModelingSessionCannPMRRow,
    WB_ModelingSessionCoeffGrpRow,
    WB_ModelingSessionCoeffGrpStRow,
    WB_ModelingSessionCoeffGrpStRRow,
    WB_ModelingSessionCoeffRuleRow,
    WB_ModelingSessionCoeffRuleRRow,
    WB_ModelingSessionConstantFRRow,
    WB_ModelingSessionCustRRow,
    WB_ModelingSessionElRow,
    WB_ModelingSessionObservationRow,
    WB_ModelingSessionProdRRow,
    WB_ModelingSessionRangeRow,
    WB_ModelingSessionRefPredictorRRow,
    WB_ModelingSessionRefRRow,
    WB_ModelingSessionRow,
    WB_ModelingSessionStageARRow,
    WB_ModelingSessionStageCRPMetaRow,
    WB_ModelingSessionStageCRPRow,
    WB_ModelingSessionStageCRPRRow,
    WB_ModelingSessionStageRow,
    WB_ModelingSessionTagRuleRRow,
    WB_ModelingSessionTermRRow,
    WB_ModelingSessionTrialRow,
    WB_ModelPredictorRelationshipRow,
    WB_ModelPredictorRow,
    WB_ModelRow,
    WB_ModelTermRelationshipRow,
    WB_ModelTermRow,
    WB_PowerMetricRelationshipRow,
    WB_ProductGroupRelationshipRow,
    WB_ProductGroupRow,
    WB_ProductHierarchyRow,
    WB_TagRow
} from "../PA.Core/PAdbSchemaRows"
import {IwbModelingSession} from "../PA.Core/PAdbSchemaRowsIF"
import {
    esWB_AffinityGroup,
    esWB_AffinityGroupItem,
    esWB_AffinitySet,
    esWB_Audit_Log,
    esWB_Customer,
    esWB_Customer_Relationship,
    esWB_Domain,
    esWB_Domain_Item,
    esWB_Entity,
    esWB_Finished_Product,
    esWB_Finished_Product_Relationship,
    esWB_Model,
    esWB_Model_Cannibalization_Relationship,
    esWB_Model_Cannibalization_Type,
    esWB_Model_Coefficient,
    esWB_Model_DataSource,
    esWB_Model_Function,
    esWB_Model_Predictor,
    esWB_Model_Term_Relationship,
    esWB_Modeling_Session,
    esWB_Modeling_Session_AffinitySet_Relationship,
    esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship,
    esWB_Modeling_Session_Cannibalization_Type_Relationship,
    esWB_Modeling_Session_Coeff_Grp,
    esWB_Modeling_Session_Coeff_GrpSt,
    esWB_Modeling_Session_Coeff_GrpStR,
    esWB_Modeling_Session_Coeff_Rule,
    esWB_Modeling_Session_Coeff_RuleR,
    esWB_Modeling_Session_ConstantFR,
    esWB_Modeling_Session_CustR,
    esWB_Modeling_Session_El,
    esWB_Modeling_Session_ElCR,
    esWB_Modeling_Session_ElR,
    esWB_Modeling_Session_Observation,
    esWB_Modeling_Session_ProdR,
    esWB_Modeling_Session_Range,
    esWB_Modeling_Session_Reference_Predictor_Relationship,
    esWB_Modeling_Session_Reference_Relationship,
    esWB_Modeling_Session_Stage,
    esWB_Modeling_Session_StageAlgorithm,
    esWB_Modeling_Session_StageCoeffRangePolicy,
    esWB_Modeling_Session_StageCoeffRangePolicyMeta,
    esWB_Modeling_Session_StageCoeffRangePolicyR,
    esWB_Modeling_Session_Tag_RuleR,
    esWB_Modeling_Session_TermR,
    esWB_Modeling_Session_Trial,
    esWB_Modeling_Session_Trial_Metric,
    esWB_Modeling_Session_Trial_PartitionStage,
    esWB_Modeling_Session_Trial_Predictor_Metric,
    esWB_Modeling_Session_Trial_PredictorR_Metric,
    esWB_Product_Attribute_Group,
    esWB_Product_Group,
    esWB_Product_Group_Relationship,
    esWB_Product_Hierarchy,
    esWB_Tag
} from "../PA.Core/PAdbSchema"
import {ESRecord} from "../PA.Core/lib/ESRecord"
import {ESDataStore} from "../PA.Core/lib/ESDataStore"
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver"
import {ASync} from "../PA.Core/Basic/ASync"
import {BehaviorSubject} from "rxjs"
import {
    IHaveModel,
    IHaveModelingSessionCalculator,
    IModelingSession,
    IModelingSessionCalculator,
    ModelingSessionChangeEvent,
    ModelingSessionTrialChangeEvent
} from "../PA.Model.Core/PA.Model.IF.Aspects"
import {IHaveFinishedProducts, IHaveProductGroups, IHaveSourceCustomers} from "../PA.Core/PA.Core.IF.Aspects"
import {ModelBO} from "./ModelBO"
import {ModelingSessionCalculator} from "../PA.Model.Services/ModelingSessionCalculator"
import {ModelingSessionBOValidations} from "./ModelingSessionBO.Validations"
import {TextUtils} from "../PA.Core/Basic/Text"
import {PAEnvironment} from "../PA.Core/PAEnvironment"
import {PASearch} from "../PA.Core/PASearch"
import {ProductHierarchyService} from "../PA.MD.Services/ProductHierarchyService"
import {CustomerHierarchyService} from "../PA.MD.Services/CustomerHierarchyService"
import {ModelingSessionService} from "../PA.Model.Services/ModelingSessionService"
import {
    IModelingSessionServiceCalculateSessionOptions,
    IModelingSessionServiceReferenceValuesResponse,
    IModelingSessionServiceResponse
} from "../PA.Model.Services/ModelingSessionServices.IF"
import {ModelUtils} from "../PA.Model.Services/ModelUtils"
import {IHaveAffinitySets} from "../PA.MD.Core/PA.MD.IF.Aspects"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils"
import {DateUtils} from "../PA.Core/Basic/Dates"
import {Product_Hierarchy_OrgLevel_Product} from "../PA.MD.Core/MD.Constants"
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry"
import {EntityTypeUtils} from "../PA.MD.Entity/EntityTypeUtils"

export interface IDataScopeChangedEvent {
    ModelingSessionBO: ModelingSessionBO;
    Row: WB_ModelingSessionRow;
    PropertyChanged: string;
    PropertyValue: any;
}

export class ModelingSessionBO
    implements IBusinessObject,
        IModelingSession,
        IHaveModel,
        IHaveModelingSessionCalculator,
        IHaveProductGroups,
        IHaveAffinitySets {
    Identity: IdentityProvider

    CreateOptions: any

    LoadOptions: any
    _bIsLoaded: boolean
    _OnLoadComplete: Promise<IBusinessObject>
    LoadProgressProvider: IProgressProvider

    ValidateOptions: any
    _bIsValidated: boolean
    ValidateMessageProvider: IMessageProvider
    ValidateProgressProvider: IProgressProvider

    SaveOptions: any
    _bIsSaved: boolean
    SaveProgressProvider: IProgressProvider

    DeleteOptions: any
    _bIsDeleted: boolean
    DeleteMessageProvider: IMessageProvider
    DeleteProgressProvider: IProgressProvider

    dbContext: PAdbContext
    drWB_ModelingSession: WB_ModelingSessionRow

    _CoefficientGroupsChanged: BehaviorSubject<ModelingSessionBO>
    _DataScopeChanged: BehaviorSubject<IDataScopeChangedEvent>

    _SolverStagesChanged: BehaviorSubject<ModelingSessionBO>

    refValuePredictorList: any

    _CannMIds: any[]
    _Algorithms: WB_DomainItemRow[]
    _BoundaryConditionPolicies: WB_DomainItemRow[]

    constructor(options?: any) {
        this.CreateOptions = options || {}

        if ("dbContext" in this.CreateOptions) this.dbContext = this.CreateOptions.dbContext

        this.Identity = new IdentityProvider({id: 0, name: "New Modeling Session"})

        this.LoadOptions = {}
        this._bIsLoaded = false
        this._OnLoadComplete = null
        this.LoadProgressProvider = new ProgressProvider("Loading", this)

        this.ValidateOptions = {}
        this._bIsValidated = false
        this.ValidateMessageProvider = new MessageProvider()
        this.ValidateProgressProvider = new ProgressProvider("Validating", this)

        this.SaveOptions = {}
        this._bIsSaved = false
        this.SaveProgressProvider = new ProgressProvider("Saving", this)

        this.DeleteOptions = {}
        this._bIsDeleted = false
        this.DeleteMessageProvider = new MessageProvider()
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this)

        this.drWB_ModelingSession = null

        this._CoefficientGroupsChanged = new BehaviorSubject<ModelingSessionBO>(undefined)
        this._DataScopeChanged = new BehaviorSubject<IDataScopeChangedEvent>(undefined)
        this._SolverStagesChanged = new BehaviorSubject<ModelingSessionBO>(undefined)

        this.IModelingSession_init()
        this.IHaveModel_init()
        this.IHaveModelingSessionCalculator_init()
        this.IHaveProductGroups_init()
        this.IHaveFinishedProducts_init()
        this.IHaveSourceCustomers_init()
        this.IModelingSessionSolver_init()
        this.IHaveAffinitySets_init()

        this._CannMIds = []
        this._Algorithms = []
        this._BoundaryConditionPolicies = []
        this.ExecutionTab_init()
    }

    async ExecutionTab_init() {
        const self = this
        const findRequest = SearchUtils.makeSearchRequest({}, "vUI_Modeling_Session_Solver_CannMs", {}, [])

        const arrCannMIds = await PASearch.findByRequest(findRequest)
        self._CannMIds = arrCannMIds

        const bcPolicyDomName = "ModelingSessionSolverBCPolicy"
        const algorithmDomName = "ModelingSessionSolverAlgorithm"
        const requiredDomains: WB_DomainRow[] = await self.dbContext.findAll(esWB_Domain, {
            where: {
                DOMAIN_ID: {inq: [bcPolicyDomName, algorithmDomName]}
            }
        })

        if (requiredDomains.length === 0) {
            return
        }

        let bcPolicyWbDomId: number
        let algorithmWbDomId: number
        for (const dom of requiredDomains) {
            switch (true) {
                case bcPolicyDomName === dom.cif.DOMAIN_ID:
                    bcPolicyWbDomId = dom.cif.WB_DOM_ID
                    break
                case algorithmDomName === dom.cif.DOMAIN_ID:
                    algorithmWbDomId = dom.cif.WB_DOM_ID
                    break
            }
        }

        const domainValues = <WB_DomainItemRow[]>await self.dbContext.findAll(esWB_Domain_Item, {
            where: {
                WB_DOM_ID: {inq: [bcPolicyWbDomId, algorithmWbDomId]},
                DELETED_IND: {neq: "1"}
            }
        })

        this._Algorithms = domainValues.filter((item) => item.cif.WB_DOM_ID === algorithmWbDomId)
        this._BoundaryConditionPolicies = domainValues.filter((item) => item.cif.WB_DOM_ID === bcPolicyWbDomId)
    }

    get CannMIds(): any[] {
        return this._CannMIds
    }

    get Algorithms(): WB_DomainItemRow[] {
        return this._Algorithms
    }

    get BoundaryConditionPolicies(): WB_DomainItemRow[] {
        return this._BoundaryConditionPolicies
    }

    getBoundaryConditionPolicyName(stageRow: WB_ModelingSessionStageRow): string {
        const bcPolicyDomItemId = `${stageRow.WB_ModelingSessionStageCRPRow.WB_ModelingSessionStageCRPMetaRow.cif.POLICY_ID}${stageRow.WB_ModelingSessionStageCRPRow.cif.STAGE_POLICY_ID}`
        const domItem = this.BoundaryConditionPolicies.find((item) => item.cif.DOMAIN_ITEM_ID === bcPolicyDomItemId)
        return domItem?.cif?.DOMAIN_ITEM_NAME ?? "Unknown BC Policy"
    }

    get WB_ModelingSession(): WB_ModelingSessionRow {
        return this.drWB_ModelingSession
    }

    get DataScopeChanged(): BehaviorSubject<IDataScopeChangedEvent> {
        return this._DataScopeChanged
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this
        this.LoadProgressProvider.start("Creating Modeling Session")
        const createOpts = _.defaultsDeep({}, self.CreateOptions, options)

        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {
            self.LoadOptions = options || {}
            if ("dbContext" in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext
            else self.dbContext = new PAdbContext()

            if (this.dbContext == null) {
                const sError = "Unable to determine dbContext for New Modeling Session."
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            // Create record using dbContext
            let aModelRow: WB_ModelRow = undefined
            self.dbContext
                .find(esWB_Model, createOpts.ModelId)
                .then((aModelRecord: WB_ModelRow) => {
                    if (aModelRecord == null) {
                        // Bad Cust ID
                        resolve(self)
                        return
                    }
                    aModelRow = aModelRecord
                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Modeling_Session)
                })
                .then((newModelingSessionRow: WB_ModelingSessionRow) => {
                    newModelingSessionRow.setDefaults()
                    self.drWB_ModelingSession = newModelingSessionRow
                    self.drWB_ModelingSession.cif.WB_MDSET_ID = createOpts?.wbMasterDataSetId || 0
                    self.drWB_ModelingSession.cif.WB_SALESORG_ID = createOpts?.wbSalesOrgId || 0
                    self.drWB_ModelingSession.cif.WB_ENTITY_ID_CUSTOMER = createOpts?.wbCustomerTypeId || 0
                    self.drWB_ModelingSession.cif.WB_CUSTH_ID = createOpts?.wbCustomerHierarchyId || 0
                    self.drWB_ModelingSession.cif.WB_ENTITY_ID_PRODUCT = createOpts?.wbProductTypeId || 0
                    self.drWB_ModelingSession.cif.WB_PRDH_ID = createOpts?.wbProductHierarchyId || 0
                    self.drWB_ModelingSession.cif.WB_ENTITY_ID_PERIOD = createOpts?.wbPeriodTypeId || 0
                    self.drWB_ModelingSession.cif.WB_PERIODH_ID = createOpts?.wbPeriodHierarchyId || 0
                    self.drWB_ModelingSession.cif.WB_MODEL_ID = createOpts.ModelId
                    self.drWB_ModelingSession.CUSTOMER_LEVEL = createOpts.customerLevel || ""
                    self.drWB_ModelingSession.PRODUCT_LEVEL = createOpts.productLevel || ""

                    self.drWB_ModelingSession.WB_ModelRow = aModelRow
                    if (self.drWB_ModelingSession?.WB_ModelRow?.cif?.MODEL_TYPE === "Cannibalization") {
                        self.drWB_ModelingSession.cif.STOP_SUBTRIAL_CANN_NOI_IND = "1"
                        self.drWB_ModelingSession.cif.STOP_MAX_REFINEMENT_IND = "1"
                        self.drWB_ModelingSession.cif.CNVG_R2_CANNREF_IND = "1"
                    }
                    self.dbContext.add(esWB_Modeling_Session, newModelingSessionRow)
                    self.Identity.setAll(
                        self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID,
                        self.WB_ModelingSession.cif.MODELING_SESSION_ID,
                        self.WB_ModelingSession.cif.MODELING_SESSION_NAME
                    )
                    self.LoadProgressProvider.setName(
                        "Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")"
                    )
                    self.Identity.listenToRecordUpdates(
                        self.WB_ModelingSession,
                        "WB_MODELING_SESSION_ID",
                        "MODELING_SESSION_ID",
                        "MODELING_SESSION_NAME"
                    )

                    return self.dbContext.find(esWB_Entity, self.drWB_ModelingSession.cif.WB_ENTITY_ID_PRODUCT)
                })
                .then((entityRow: WB_EntityRow) => {
                    self.drWB_ModelingSession.WB_EntityRow_Product = entityRow
                    return self._AfterBoLoadCompleteInternal()
                })
                .then((ignore) => {
                    self.LoadProgressProvider.finish()
                    self._bIsLoaded = true
                    self._OnLoadComplete = null
                    resolve(self)
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })
        })

        return this._OnLoadComplete
    }

    Load(anId: number, options?: object): Promise<IBusinessObject> {
        const self = this

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")")

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {
            if (self.bIsLoaded) {
                const sError = "Modeling Session already loaded."
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            self.LoadOptions = options || {}

            if ("dbContext" in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext
            else if (self.dbContext == null) self.dbContext = new PAdbContext()

            if (this.dbContext == null) {
                const sError = "Unable to determine dbContext for Modeling Session."
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            if ("RecordResolver" in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = ModelingSessionBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = ModelingSessionBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    const newModelingSessionRow: any = recordResolver.get(esWB_Modeling_Session, anId)
                    if (_.isEmpty(newModelingSessionRow)) {
                        self._OnLoadComplete = null
                        self.LoadProgressProvider.exception("Id not found.")
                        resolve(self)
                        return
                    }

                    self.drWB_ModelingSession = newModelingSessionRow
                    self.Identity.setAll(
                        self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID,
                        self.WB_ModelingSession.cif.MODELING_SESSION_ID,
                        self.WB_ModelingSession.cif.MODELING_SESSION_NAME
                    )
                    self.LoadProgressProvider.setName(
                        "Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")"
                    )
                    self.Identity.listenToRecordUpdates(
                        self.WB_ModelingSession,
                        "WB_MODELING_SESSION_ID",
                        "MODELING_SESSION_ID",
                        "MODELING_SESSION_NAME"
                    )

                    return self.dbContext.findAll(esWB_Entity, {
                        where: {
                            WB_ENTITY_ID: {
                                inq: [
                                    self.drWB_ModelingSession.cif.WB_ENTITY_ID_PRODUCT,
                                    self.drWB_ModelingSession.cif.WB_ENTITY_ID_CUSTOMER
                                ]
                            }
                        }
                    })
                })
                .then((arrEntity: WB_EntityRow[]) => {
                    if (arrEntity.length > 0) {
                        self.drWB_ModelingSession.CUSTOMER_LEVEL = _.first(
                            _.filter(
                                arrEntity,
                                (entity) =>
                                    entity.cif.WB_ENTITY_ID == self.drWB_ModelingSession.cif.WB_ENTITY_ID_CUSTOMER
                            )
                        ).cif.ENTITY_ID
                        self.drWB_ModelingSession.PRODUCT_LEVEL = _.first(
                            _.filter(
                                arrEntity,
                                (entity) =>
                                    entity.cif.WB_ENTITY_ID == self.drWB_ModelingSession.cif.WB_ENTITY_ID_PRODUCT
                            )
                        ).cif.ENTITY_ID
                    }
                    return self._AfterBoLoadCompleteInternal()
                })
                .then((ignore) => {
                    self._bIsLoaded = true
                    self._OnLoadComplete = null
                    self.LoadProgressProvider.finish()
                    resolve(self)
                })
                .catch((err: any) => {
                    self._OnLoadComplete = null
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })
        })

        return this._OnLoadComplete
    }

    Reload(opts?: any): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {
            if (!self.bIsLoaded) {
                error("Reload: Modeling Session not loaded")
                return
            }

            const id = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID

            self.dbContext
                .purgeCache(esWB_Modeling_Session, self.WB_ModelingSession, {})
                .then((ignore) => {
                    self._bIsLoaded = false
                    self.IModelingSession_BeforeReload()
                    self.IHaveModelingSessionCalculator_BeforeReload()
                    self.IHaveProductGroups_BeforeReload()
                    self.IHaveFinishedProducts_BeforeReload()
                    self.IHaveSourceCustomers_BeforeReload()
                    self.IHaveModel_BeforeReload()

                    self._OnLoadComplete = undefined

                    return self.Load(id, {dbContext: self.dbContext})
                })
                .then((aBO) => {
                    if (!aBO.bIsLoaded) {
                        console.log("Unable to Load BO in Reload function")
                    }
                    // Should we fire anyexisting Behavior Subjects?
                    self.ProductGroupsChanged.next(self)
                    self.SourceCustomersChanged.next(self)
                    self.IModelingSession_AfterReload()
                    self.OnModelingSessionRefRCollectionChanged.next(self)
                    self.SolverTrialsChanged.next(self)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    private _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            const tasks: Promise<any>[] = []
            self.LoadProgressProvider.setProgressMessage("ModelingSession.PostLoad", "Processing Loaded Data")
            tasks.push(self.IModelingSession_OnLoadComplete())
            tasks.push(self.ModelingSessionCoeffRange_sync())
            tasks.push(self.syncModelingSessionRefReqPredictors())
            tasks.push(self.syncModelingSessionCannTypeRelRecords())
            tasks.push(self.syncModelingSessionTagRulesRecords())
            tasks.push(self.syncModelingSessionCoreElasticitiesRecords())
            tasks.push(self.setupInitialSolverStage())

            Promise.all(tasks)
                .then((ignore) => {
                    return self.IHaveAffinitySets_OnLoadCompleted()
                })
                .then((ignore) => {
                    return self.IHaveModelingSessionCalculator_OnLoadComplete()
                })
                .then(() => {
                    if (
                        _.filter(self.drWB_ModelingSession.WB_ModelingSessionCustRRows, (row) => row.isActive).length >
                        0 &&
                        _.filter(self.drWB_ModelingSession.WB_ModelingSessionProdRRows, (row) => row.isActive).length >
                        0
                    )
                        return self.onDataScopeChanged()
                })
                .then((ignore) => {
                    resolve()
                })
                .catch((err: any) => {
                    error(err)
                })
        })
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        if (this._bIsLoaded) {
            return ASync.resolve(this)
        }
        return this._OnLoadComplete
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded
    }

    get bHasDataScope(): boolean {
        const self = this
        if (
            _.filter(self.drWB_ModelingSession.WB_ModelingSessionProdRRows, (row) => row.isActive).length > 0 &&
            !_.isEmpty(self.dataDateRange)
        )
            return true
        return false
    }

    Validate(options?: any): Promise<IBusinessObject> {
        const self = this
        this.ValidateMessageProvider.clearMessages()
        this.ValidateProgressProvider.start(
            "Validating " +
            self.WB_ModelingSession.cif.MODELING_SESSION_NAME +
            "(" +
            self.WB_ModelingSession.cif.MODELING_SESSION_ID +
            ")"
        )
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {}

            if (self.dbContext == undefined) {
                const sError = "Unable to determine dbContext to Validate Modeling Session."
                self.ValidateProgressProvider.exception(sError)
                reject(sError)
            }

            ModelingSessionBOValidations.Validate(self)
                .then((ignore) => {
                    self._bIsValidated = self.ValidateMessageProvider.countMessages(MessageType.Error) <= 0
                    self.ValidateProgressProvider.finish()
                    resolve(self)
                })
                .catch((err) => {
                    self._bIsValidated = false
                    self.ValidateProgressProvider.exception(err)
                    resolve(self)
                })
        })
    }

    get bIsValidated(): boolean {
        return this._bIsValidated
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this
        const wbModelingSession = <IwbModelingSession>self.drWB_ModelingSession
        this.SaveProgressProvider.start(
            "Saving " + wbModelingSession.MODELING_SESSION_NAME + "(" + wbModelingSession.MODELING_SESSION_ID + ")"
        )

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false
                const sError = "Unable to determine dbContext to Save Modeling Session"
                self.SaveProgressProvider.exception(sError)
                reject(sError)
                return
            }

            self.SaveOptions = options || {}

            let saveFunction: (
                esName: string,
                saveRecords: ESRecord[] | ESRecord,
                options?: any
            ) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            let bDone = false
            self.Validate({}).then((ignore) => {
                if (!self.bIsValidated) {
                    self._bIsSaved = false
                    bDone = true
                    self.SaveProgressProvider.finish()
                    resolve(self)
                    return
                }
                return saveFunction(esWB_Modeling_Session, self.drWB_ModelingSession, {})
                    .then((ignore) => {
                        const tasks: Promise<any>[] = []
                        tasks.push(saveFunction(esWB_Modeling_Session, self.drWB_ModelingSession))
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_CustR,
                                self.drWB_ModelingSession.WB_ModelingSessionCustRRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_ProdR,
                                self.drWB_ModelingSession.WB_ModelingSessionProdRRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Range,
                                self.drWB_ModelingSession.WB_ModelingSessionRangeRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Trial,
                                self.drWB_ModelingSession.WB_ModelingSessionTrialRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Coeff_Rule,
                                self.drWB_ModelingSession.WB_ModelingSessionCoeffRuleRows
                            )
                        )
                        _.forEach(
                            self.drWB_ModelingSession.WB_ModelingSessionCoeffRuleRows,
                            (aRow: WB_ModelingSessionCoeffRuleRow) => {
                                tasks.push(
                                    saveFunction(
                                        esWB_Modeling_Session_Coeff_RuleR,
                                        aRow.WB_ModelingSessionCoeffRuleRRows
                                    )
                                )
                            }
                        )
                        // tasks.push(saveFunction(esWB_Modeling_Session_Trial_Residual_Metric, self.drWB_ModelingSession.WB_ModelingSessionTrialRsdMtRows))
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Tag_RuleR,
                                self.drWB_ModelingSession.WB_ModelingSessionTagRuleRRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Observation,
                                self.drWB_ModelingSession.WB_ModelingSessionObservationRows
                            )
                        )

                        _.forEach(
                            self.drWB_ModelingSession.WB_ModelingSessionRefPredictorRRows,
                            (aRefPredRow: WB_ModelingSessionRefPredictorRRow) => {
                                if (aRefPredRow.cif.DETERMINATION_POLICY == "UsePredictor")
                                    aRefPredRow.cif.USE_REF_PREDICTOR_IND = "1"
                            }
                        )

                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Reference_Predictor_Relationship,
                                self.drWB_ModelingSession.WB_ModelingSessionRefPredictorRRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Cannibalization_Type_Relationship,
                                self.drWB_ModelingSession.WB_ModelingSessionCannTypeRelRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Reference_Relationship,
                                self.drWB_ModelingSession.WB_ModelingSessionRefRRows
                            )
                        )

                        _.forEach(
                            self.drWB_ModelingSession.WB_ModelingSessionCannTypeRelRows,
                            (aCannRelRow: WB_ModelingSessionCannMRRow) => {
                                tasks.push(
                                    saveFunction(
                                        esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship,
                                        aCannRelRow.WB_ModelingSessionCannPMRRows
                                    )
                                )
                                tasks.push(
                                    saveFunction(
                                        esWB_Modeling_Session_AffinitySet_Relationship,
                                        aCannRelRow.WB_ModelingSessionASRRows
                                    )
                                )
                            }
                        )

                        tasks.push(
                            saveFunction(esWB_Modeling_Session_El, self.drWB_ModelingSession.WB_ModelingSessionElRows)
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_ElR,
                                self.drWB_ModelingSession.WB_ModelingSessionElRRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_ElCR,
                                self.drWB_ModelingSession.WB_ModelingSessionElCRRows
                            )
                        )

                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_TermR,
                                self.drWB_ModelingSession.WB_ModelingSessionTermRRows
                            )
                        )
                        /*_.forEach(self.drWB_ModelingSession.WB_ModelingSessionTermRRows, (aTermRRow: WB_ModelingSessionTermRRow) => {
                                if (aTermRRow.cif.NEUTRALIZED_IND == "1")
                                    tasks.push(saveFunction(esWB_Modeling_Session_TermR, aTermRRow))
                                else
                                    self.removeModelingSessionTermR(aTermRRow.cif.WB_MODELING_SESSION_TERMR_ID)
                            })
                            tasks.push(saveFunction(esWB_Modeling_Session_TermR, self.drWB_ModelingSession.WB_ModelingSessionTermRRows))*/

                        //coefficient groups
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Coeff_Grp,
                                self.drWB_ModelingSession.WB_ModelingSessionCoeffGrpRows
                            )
                        )
                        _.forEach(
                            self.drWB_ModelingSession.WB_ModelingSessionCoeffGrpRows,
                            (aRow: WB_ModelingSessionCoeffGrpRow) => {
                                tasks.push(
                                    saveFunction(
                                        esWB_Modeling_Session_Coeff_GrpSt,
                                        aRow.WB_ModelingSessionCoeffGrpStRows
                                    )
                                )
                                _.forEach(
                                    aRow.WB_ModelingSessionCoeffGrpStRows,
                                    (aRow: WB_ModelingSessionCoeffGrpStRow) => {
                                        tasks.push(
                                            saveFunction(
                                                esWB_Modeling_Session_Coeff_GrpStR,
                                                aRow.WB_ModelingSessionCoeffGrpStRRows
                                            )
                                        )
                                    }
                                )
                            }
                        )

                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_ConstantFR,
                                self.drWB_ModelingSession.WB_ModelingSessionConstantFRRows
                            )
                        )
                        tasks.push(
                            saveFunction(
                                esWB_Modeling_Session_Stage,
                                self.drWB_ModelingSession.WB_ModelingSessionStageRows
                            )
                        )
                        _.forEach(
                            self.drWB_ModelingSession.WB_ModelingSessionStageRows,
                            (aRow: WB_ModelingSessionStageRow) => {
                                tasks.push(
                                    saveFunction(
                                        esWB_Modeling_Session_StageAlgorithm,
                                        aRow.WB_ModelingSessionStageARRows
                                    )
                                )
                                tasks.push(
                                    saveFunction(
                                        esWB_Modeling_Session_StageCoeffRangePolicy,
                                        aRow.WB_ModelingSessionStageCRPRow
                                    )
                                )
                                tasks.push(
                                    saveFunction(
                                        esWB_Modeling_Session_StageCoeffRangePolicyR,
                                        aRow.WB_ModelingSessionStageCRPRow?.WB_ModelingSessionStageCRPRRows
                                    )
                                )
                            }
                        )

                        return Promise.all(tasks)
                    })
                    .then(() => {
                        if (bBatch) {
                            self.dbContext.addBatchCompleteListener(() => {
                                self._bIsSaved = true
                                LeaseRegistry.generateLeaseInvalidationByClassList([
                                    LeaseRegistry.getLeaseClass(
                                        LeaseRegistry.Lease_Subject_ModelingSession,
                                        self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
                                    )
                                ])
                            })
                        } else {
                            self._bIsSaved = true
                            LeaseRegistry.generateLeaseInvalidationByClassList([
                                LeaseRegistry.getLeaseClass(
                                    LeaseRegistry.Lease_Subject_ModelingSession,
                                    self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
                                )
                            ])
                        }
                        self.SaveProgressProvider.finish()
                        resolve(self)
                    })
                    .catch((err) => {
                        self.SaveProgressProvider.exception(err)
                        reject(self)
                    })
            })
        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this
        const wbModelingSession = <IwbModelingSession>self.drWB_ModelingSession
        this.DeleteMessageProvider.clearMessages()
        this.DeleteProgressProvider.start(
            "Deleting " + wbModelingSession.MODELING_SESSION_NAME + "(" + wbModelingSession.MODELING_SESSION_ID + ")"
        )

        return new Promise<IBusinessObject>((resolve, error) => {
            // 1. Validate if we can delete the Model

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ModelingSession.markDeleted()

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true
                        self.DeleteProgressProvider.finish()
                        resolve(self)
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true
                self.DeleteProgressProvider.finish()
                resolve(self)
            }
        })
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted
    }

    //</editor-fold>

    //<editor-fold desc = "IModelingSession operations">

    private _ModelingSessionPropertyChanged: BehaviorSubject<ModelingSessionChangeEvent>
    private _ModelingSessionTrialPropertyChanged: BehaviorSubject<ModelingSessionTrialChangeEvent>
    private _ModelingSessionTrialCollectionChanged: BehaviorSubject<IModelingSession>
    private _OnModelingSessionRangesCollectionChanged: BehaviorSubject<ModelingSessionChangeEvent> = undefined
    private _OnModelingSessionRefRCollectionChanged: BehaviorSubject<IModelingSession>

    IModelingSession_init() {
        this._ModelingSessionPropertyChanged = new BehaviorSubject<ModelingSessionChangeEvent>(undefined)
        this._ModelingSessionTrialPropertyChanged = new BehaviorSubject<ModelingSessionTrialChangeEvent>(undefined)
        this._OnModelingSessionRangesCollectionChanged = new BehaviorSubject<ModelingSessionChangeEvent>(undefined)
        this._OnModelingSessionRefRCollectionChanged = new BehaviorSubject<IModelingSession>(undefined)
    }

    private IModelingSession_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.WB_ModelingSession.setupOnChangeEvents([], self.IModelingSession_onRecordChange.bind(self), self)

            _.forEach(self.WB_ModelingSession.WB_ModelingSessionTrialRows, (aRow) => {
                if (!aRow.isActive) {
                    return
                }
                aRow.setupOnChangeEvents([], self.IModelingSessionTrial_onRecordChange.bind(self), self)
            })

            resolve()
        })
    }

    private IModelingSession_BeforeReload(): void {
        const self = this
        //
        // Turn off record events ?
        self.WB_ModelingSession.off()

        _.forEach(self.WB_ModelingSession.WB_ModelingSessionTrialRows, (aRow) => {
            aRow.off()
        })

        this.dbContext.purgeCache(
            esWB_Modeling_Session_Reference_Relationship,
            this.WB_ModelingSession.WB_ModelingSessionRefRRows,
            {}
        )
        this.dbContext.purgeCache(esWB_Model_Term_Relationship, [], {})
    }

    private IModelingSession_AfterReload(): void {
        const self = this
        // Re-setup the Record Events

        self.WB_ModelingSession.setupOnChangeEvents([], self.IModelingSession_onRecordChange.bind(self), self)

        _.forEach(self.WB_ModelingSession.WB_ModelingSessionTrialRows, (aRow) => {
            if (!aRow.isActive) {
                return
            }
            aRow.setupOnChangeEvents([], self.IModelingSessionTrial_onRecordChange.bind(self), self)
        })
    }

    private IModelingSession_onRecordChange(
        record: WB_ModelingSessionRow,
        propertyName: string,
        propertyValue: any,
        options: ModelingSessionBO
    ) {
        this.OnModelingSessionPropertyChanged.next({
            ModelingSessionBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    private IModelingSessionTrial_onRecordChange(
        record: WB_ModelingSessionTrialRow,
        propertyName: string,
        propertyValue: any,
        options: ModelingSessionBO
    ) {
        this.OnModelingSessionTrialPropertyChanged.next({
            ModelingSessionBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    addTrial(): Promise<WB_ModelingSessionTrialRow> {
        const self = this

        return new Promise<WB_ModelingSessionTrialRow>((resolve, error) => {
            self.dbContext
                .createRecordWithKey(esWB_Modeling_Session_Trial)
                .then((returnRow: WB_ModelingSessionTrialRow) => {
                    returnRow.setDefaults()
                    returnRow.cif.WB_MODELING_SESSION_ID = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
                    self.dbContext.add(esWB_Modeling_Session_Trial, returnRow)
                    returnRow.setupOnChangeEvents([], self.IModelingSessionTrial_onRecordChange.bind(self), self)
                    self.OnModelingSessionTrialCollectionChanged.next(self)
                    resolve(returnRow)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeTrial(wbModelingSessionTrialId: number): Promise<void> {
        const self = this

        _.forEach(self.drWB_ModelingSession.WB_ModelingSessionTrialRows, (aTrialRow: WB_ModelingSessionTrialRow) => {
            if (aTrialRow.isActive && aTrialRow.cif.WB_MODELING_SESSION_TRIAL_ID == wbModelingSessionTrialId) {
                aTrialRow.markDeleted()
                aTrialRow.off()
            }
        })

        self.OnModelingSessionTrialCollectionChanged.next(self)

        return ASync.resolve()
    }

    get ModelingSessionTrials(): WB_ModelingSessionTrialRow[] {
        return _.filter(this.WB_ModelingSession.WB_ModelingSessionTrialRows, (a) => a.isActive)
    }

    public async getCurrentTrialRow(): Promise<WB_ModelingSessionTrialRow> {
        const dbContext = new PAdbContext()
        const arrRows = await dbContext.findAll(esWB_Modeling_Session_Trial, {
            where: {
                WB_MODELING_SESSION_ID: this.WB_ModelingSession.cif.WB_MODELING_SESSION_ID,
                DELETED_IND: {neq: "1"}
            }
        })
        this.WB_ModelingSession.WB_ModelingSessionTrialRows = arrRows

        return _.first(_.filter(this.WB_ModelingSession.WB_ModelingSessionTrialRows, (a) => a.isActive))
    }

    get OnModelingSessionPropertyChanged(): BehaviorSubject<ModelingSessionChangeEvent> {
        return this._ModelingSessionPropertyChanged
    }

    get OnModelingSessionTrialPropertyChanged(): BehaviorSubject<ModelingSessionTrialChangeEvent> {
        return this._ModelingSessionTrialPropertyChanged
    }

    get OnModelingSessionTrialCollectionChanged(): BehaviorSubject<IModelingSession> {
        return this._ModelingSessionTrialCollectionChanged
    }

    get OnModelingSessionRefRCollectionChanged(): BehaviorSubject<IModelingSession> {
        return this._OnModelingSessionRefRCollectionChanged
    }

    //</editor-fold>

    //<editor-fold desc = "Modeling Session Add / Remove Coeff Range operations">

    async addModelingSessionCoeffRange(wbCoeffId: number): Promise<WB_ModelingSessionRangeRow> {
        const self = this

        //TODO:  Check if it exist..?

        let coeffRow: WB_ModelCoefficientRow = undefined
        coeffRow = await self.dbContext.find(esWB_Model_Coefficient, wbCoeffId)

        if (_.isEmpty(coeffRow)) return undefined

        const aNewRow: WB_ModelingSessionRangeRow = <any>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_Range)
        )

        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID
        aNewRow.WB_ModelingSessionRow = self.drWB_ModelingSession
        aNewRow.cif.WB_MODEL_COEFFICIENT_ID = coeffRow.cif.WB_MODEL_COEFFICIENT_ID
        aNewRow.WB_ModelCoefficientRow = coeffRow
        self.dbContext.add(esWB_Modeling_Session_Range, aNewRow)
        return aNewRow
    }

    removeModelingSessionCoeffRange(aWB_MODELING_SESSION_RANGE_ID: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionRangeRows,
                (aModelSessionRangeRow: WB_ModelingSessionRangeRow) => {
                    if (
                        aModelSessionRangeRow.isActive &&
                        aModelSessionRangeRow.cif.WB_MODELING_SESSION_RANGE_ID == aWB_MODELING_SESSION_RANGE_ID
                    ) {
                        aModelSessionRangeRow.markDeleted()
                    }
                }
            )

            resolve()
        })
    }

    async ModelingSessionCoeffRange_sync(): Promise<void> {
        const self = this

        const arrCoeffs = await ModelUtils.getModelCoefficientList(self.WB_ModelingSession.cif.WB_MODEL_ID, {
            bSkipCache: true,
            dbContext: self.dbContext
        })
        const arrCannCoeffs = await ModelUtils.getModelCannCoefficientList(self.WB_ModelingSession.cif.WB_MODEL_ID, {
            bSkipCache: true,
            dbContext: self.dbContext
        })

        const dctCoeffs = _.keyBy(_.union(arrCoeffs, arrCannCoeffs), (a) => a.cif.WB_MODEL_COEFFICIENT_ID)
        const dctCoeffs_Missing = _.clone(dctCoeffs)
        const dctCoeffs_Existing: { [wbCoeffId: number]: number } = {}

        _.forEach(self.WB_ModelingSession.WB_ModelingSessionRangeRows, (aRow) => {
            if (!aRow.isActive) return

            const wbCoeffId = _.toNumber(aRow.cif.WB_MODEL_COEFFICIENT_ID)

            // Remove Dups
            if (wbCoeffId in dctCoeffs_Existing) {
                aRow.markDeleted()
                return
            }

            // Track Existing
            dctCoeffs_Existing[wbCoeffId] = wbCoeffId

            // Check for Extra
            if (!(wbCoeffId in dctCoeffs)) {
                aRow.markDeleted()
                return
            }

            delete dctCoeffs_Missing[wbCoeffId]
        })

        // Add Missing
        for (const coeffRow of _.values(dctCoeffs_Missing)) {
            await self.addModelingSessionCoeffRange(coeffRow.cif.WB_MODEL_COEFFICIENT_ID)
        }
    }

    async syncModelingSessionRefReqPredictors(): Promise<void> {
        const self = this
        await self.OnIHaveModelLoaded
        const arrRefReqPredictors = await self._Model.getPredictorsRequiringRefValues()

        const arrModelPredictorRels = _.map(
            _.filter(
                self._Model.WB_Model.WB_ModelPredictorRelationshipRows,
                (aModelPredRRow: WB_ModelPredictorRelationshipRow) => aModelPredRRow.isActive
            ),
            (aModelPredRel: WB_ModelPredictorRelationshipRow) => {
                return aModelPredRel.WB_ModelPredictorRow
            }
        )

        const arrPredictorsToBeAdded = _.intersection(arrRefReqPredictors, arrModelPredictorRels)

        const dctRefReqPredictors = _.keyBy(
            arrPredictorsToBeAdded,
            (a: WB_ModelPredictorRow) => a.cif.WB_MODEL_PREDICTOR_ID
        )
        const dctRefReqPredictors_Missing = _.clone(dctRefReqPredictors)
        const dctRefReqPredictors_Existing: { [wbMdlPrdectorId: number]: number } = {}

        _.forEach(
            self.WB_ModelingSession.WB_ModelingSessionRefPredictorRRows,
            (aRow: WB_ModelingSessionRefPredictorRRow) => {
                if (!aRow.isActive) return

                const wbMdlPrdectorId = _.toNumber(aRow.cif.WB_MODEL_PREDICTOR_ID)

                // Remove Dups
                if (wbMdlPrdectorId in dctRefReqPredictors_Existing) {
                    aRow.markDeleted()
                    return
                }

                // Track Existing
                dctRefReqPredictors_Existing[wbMdlPrdectorId] = wbMdlPrdectorId

                // Check for Extra
                if (!(wbMdlPrdectorId in dctRefReqPredictors)) {
                    aRow.markDeleted()
                    return
                }

                delete dctRefReqPredictors_Missing[wbMdlPrdectorId]
            }
        )

        // Add Missing
        for (const coeffRow of _.values(dctRefReqPredictors_Missing)) {
            await self.addModelingSessionRefReqPredictor(coeffRow.cif.WB_MODEL_PREDICTOR_ID)
        }
    }

    async addModelingSessionRefReqPredictor(wbCoeffId: number): Promise<WB_ModelingSessionRefPredictorRRow> {
        const self = this

        let coeffRow: WB_ModelingSessionRefPredictorRRow = undefined
        coeffRow = await self.dbContext.find(esWB_Modeling_Session_Reference_Predictor_Relationship, wbCoeffId)

        // if(_.isEmpty(coeffRow))
        //     return undefined

        const aNewRow: WB_ModelingSessionRefPredictorRRow = <any>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_Reference_Predictor_Relationship)
        )

        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID
        aNewRow.cif.WB_MODEL_PREDICTOR_ID = wbCoeffId
        aNewRow.WB_ModelingSessionRow = self.drWB_ModelingSession
        self.dbContext.add(esWB_Modeling_Session_Reference_Predictor_Relationship, aNewRow)
        return aNewRow
    }

    async syncModelingSessionCannTypeRelRecords(): Promise<void> {
        const self = this
        await self.OnIHaveModelLoaded
        const arrCannTypeRelIds = _.filter(
            self._Model.WB_Model.WB_ModelCannibalizationRelationshipRows,
            (a) => a.isActive
        )

        const dctMdlCannTypeIds = _.keyBy(
            arrCannTypeRelIds,
            (a: WB_ModelCannibalizationRelationshipRow) => a.cif.WB_MODEL_CANNIBALIZATIONM_ID
        )
        const dctMdlCannTypeIds_Missing = _.clone(dctMdlCannTypeIds)
        const dctMdlCannTypeIds_Existing: { [wbMdlCannTypeId: number]: number } = {}

        _.forEach(self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows, (aRow: WB_ModelingSessionCannMRRow) => {
            if (!aRow.isActive) return

            const wbMdlCannTypeId = _.toNumber(aRow.cif.WB_MODEL_CANNIBALIZATIONM_ID)

            // Remove Dups
            if (wbMdlCannTypeId in dctMdlCannTypeIds_Existing) {
                aRow.markDeleted()
                return
            }

            // Track Existing
            dctMdlCannTypeIds_Existing[wbMdlCannTypeId] = wbMdlCannTypeId

            // Check for Extra
            if (!(wbMdlCannTypeId in dctMdlCannTypeIds)) {
                aRow.markDeleted()
                return
            }

            delete dctMdlCannTypeIds_Missing[wbMdlCannTypeId]
        })

        // Add Missing
        for (const cannTypeRow of _.values(dctMdlCannTypeIds_Missing)) {
            await self.addModelingSessionCannTypeRecord(
                cannTypeRow.cif.WB_MODEL_CANNIBALIZATIONM_ID,
                cannTypeRow.cif.WB_MODEL_CANNR_ID
            )
        }
    }

    async syncModelingSessionTagRulesRecords(): Promise<void> {
        const self = this

        //get tags with Tag Type = “MODEL OBSERVATION” or "MODEL STATISTICS" and “Reserved” = 1
        const findRequest = SearchUtils.makeSearchRequest({}, "vUI_Modeling_Session_Tag_Rules", {}, [])

        const arrTags = await PASearch.findByRequest(findRequest)

        const dctTags = _.keyBy(arrTags, (a) => a.WB_TAG_ID)
        const dctTags_Missing = _.clone(dctTags)

        const recordResolver = new ESRecordResolver(self.dbContext, {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        })

        const dctTags_Existing: { [wbTagId: number]: number } = {}

        /*for(let tagRuleR of self.WB_ModelingSession.WB_ModelingSessionTagRuleRRows) {

            if (tagRuleR.isActive) {
                let wbTagId = _.toNumber(tagRuleR.cif.WB_TAG_ID)
                let tagRow: WB_TagRow[] = await recordResolver.queryAllWithRelationships(esWB_Tag, {WB_TAG_ID: wbTagId})
                if(!_.isEmpty(tagRow))
                    tagRuleR.WB_TagRow = tagRow[0]
            }
        }*/

        _.forEach(self.WB_ModelingSession.WB_ModelingSessionTagRuleRRows, (aRow: WB_ModelingSessionTagRuleRRow) => {
            if (!aRow.isActive) return

            const wbTagId = _.toNumber(aRow.cif.WB_TAG_ID)

            // Remove Dups
            if (wbTagId in dctTags_Existing) {
                aRow.markDeleted()
                return
            }

            // Track Existing
            dctTags_Existing[wbTagId] = wbTagId

            // Check for Extra
            if (!(wbTagId in dctTags)) {
                aRow.markDeleted()
                return
            }

            delete dctTags_Missing[wbTagId]
        })

        // Add Missing
        for (const tagRule of _.values(dctTags_Missing)) {
            await self.addModelingSessionTagRuleR(tagRule.WB_TAG_ID, {})
        }
    }

    async syncModelingSessionCoreElasticitiesRecords(): Promise<void> {
        const self = this

        await self.OnIHaveModelLoaded

        self.WB_ModelingSession.cif.ELASTICITY_START_DT =
            self.WB_ModelingSession.cif.ELASTICITY_START_DT == "18000101"
                ? self.WB_ModelingSession.cif.START_DT
                : self.WB_ModelingSession.cif.ELASTICITY_START_DT
        self.WB_ModelingSession.cif.ELASTICITY_END_DT =
            self.WB_ModelingSession.cif.ELASTICITY_END_DT == "18000101"
                ? self.WB_ModelingSession.cif.END_DT
                : self.WB_ModelingSession.cif.ELASTICITY_END_DT

        const arrModelPredictorRels = _.map(
            _.filter(
                self._Model.WB_Model.WB_ModelPredictorRelationshipRows,
                (aModelPredRRow: WB_ModelPredictorRelationshipRow) => aModelPredRRow.isActive
            ),
            (aModelPredRel: WB_ModelPredictorRelationshipRow) => {
                return aModelPredRel.WB_ModelPredictorRow
            }
        )

        const dctEls = _.keyBy(arrModelPredictorRels, (a: WB_ModelPredictorRow) => a.cif.WB_MODEL_PREDICTOR_ID)
        const dctEls_Missing = _.clone(dctEls)

        const dctEls_Existing: { [wbElId: number]: number } = {}

        _.forEach(self.WB_ModelingSession.WB_ModelingSessionElRows, (aRow: WB_ModelingSessionElRow) => {
            if (!aRow.isActive) return

            const wbElId = _.toNumber(aRow.cif.WB_MODEL_PREDICTOR_ID)

            // Remove Dups
            if (wbElId in dctEls_Existing) {
                aRow.markDeleted()
                return
            }

            // Track Existing
            dctEls_Existing[wbElId] = wbElId

            // Check for Extra
            if (!(wbElId in dctEls)) {
                aRow.markDeleted()
                return
            }

            delete dctEls_Missing[wbElId]
        })

        // Add Missing
        for (const predictor of _.values(dctEls_Missing)) {
            await self.addModelingSessionEl(predictor)
        }
    }

    async addModelingSessionEl(predictorRow: WB_ModelPredictorRow): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.dbContext
                .createRecordWithKey(esWB_Modeling_Session_El)
                .then((aNewRow: WB_ModelingSessionElRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_MODEL_PREDICTOR_ID = predictorRow.cif.WB_MODEL_PREDICTOR_ID
                    aNewRow.cif.WB_MODELING_SESSION_ID = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
                    aNewRow.cif.CALC_IND = "1"

                    const metricMapping = predictorRow.cif.PREDICTOR_META_ID

                    if (
                        metricMapping != "ACVDisplay" &&
                        metricMapping != "ACVFeature" &&
                        metricMapping != "ACVFD" &&
                        metricMapping != "TPR"
                    ) {
                        aNewRow.cif.CALC_METHOD = "PcntOfAverage"
                        aNewRow.cif.NEUTRALIZING_METHOD = "Average"
                    }

                    self.dbContext.add(esWB_Modeling_Session_El, aNewRow)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    async addModelingSessionCannTypeRecord(
        wbCannTypeId: number,
        wbModelCannRId: number
    ): Promise<WB_ModelingSessionCannMRRow> {
        const self = this

        let cannRRow: WB_ModelCannibalizationRelationshipRow = undefined
        cannRRow = await self.dbContext.find(esWB_Model_Cannibalization_Relationship, wbModelCannRId)
        if (_.isEmpty(cannRRow)) return

        let cannTypeRow: WB_ModelCannibalizationTypeRow = undefined
        cannTypeRow = await self.dbContext.find(esWB_Model_Cannibalization_Type, wbCannTypeId)

        if (_.isEmpty(cannTypeRow)) return

        const aNewRow: WB_ModelingSessionCannMRRow = <any>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_Cannibalization_Type_Relationship)
        )

        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID
        aNewRow.cif.WB_MODEL_CANNIBALIZATIONM_ID = wbCannTypeId
        aNewRow.cif.WB_MODEL_CANNR_ID = wbModelCannRId
        aNewRow.WB_ModelingSessionRow = self.drWB_ModelingSession
        aNewRow.WB_ModelCannibalizationRelationshipRow = cannRRow
        aNewRow.WB_ModelCannibalizationTypeRow = cannTypeRow
        self.dbContext.add(esWB_Modeling_Session_Cannibalization_Type_Relationship, aNewRow)

        const arrPowerMetricRelRows: WB_PowerMetricRelationshipRow[] = _.filter(
            cannRRow.WB_PowerMetricRow.WB_PowerMetricRelationshipRows,
            (a) => a.isActive
        )
        for (let i = 0; i < arrPowerMetricRelRows.length; i++) {
            const powerMetricRelRow: WB_PowerMetricRelationshipRow = arrPowerMetricRelRows[i]
            const aNewPMRRow: WB_ModelingSessionCannPMRRow = <any>(
                await self.dbContext.createRecordWithKey(
                    esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship
                )
            )

            aNewPMRRow.setDefaults()
            aNewPMRRow.cif.WB_MODEL_PREDICTOR_ID = powerMetricRelRow.cif.WB_MODEL_PREDICTOR_ID
            aNewPMRRow.cif.WB_MODELING_SESSION_CANNMR_ID = aNewRow.cif.WB_MODELING_SESSION_CANNMR_ID
            aNewPMRRow.cif.WEIGHT = powerMetricRelRow.cif.DEFAULT_WEIGHT

            const modelPredictorRow: WB_ModelPredictorRow = await self.dbContext.find(
                esWB_Model_Predictor,
                powerMetricRelRow.cif.WB_MODEL_PREDICTOR_ID
            )
            aNewPMRRow.WB_ModelPredictorRow = modelPredictorRow

            aNewPMRRow.WB_ModelingSessionCannMRRow = aNewRow

            self.dbContext.add(esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship, aNewPMRRow)
        }

        return aNewRow
    }

    //</editor-fold>

    //<editor-fold desc = "Modeling Session TermR operations">
    async addModelingSessionTermR(
        wbCustId: number,
        wbProdId: number,
        wbTermId: number
    ): Promise<WB_ModelingSessionTermRRow> {
        const self = this

        return new Promise<WB_ModelingSessionTermRRow>((resolve, error) => {
            self.dbContext
                .createRecordWithKey(esWB_Modeling_Session_TermR)
                .then((aNewRow: WB_ModelingSessionTermRRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_MODEL_TERM_ID = wbTermId
                    aNewRow.cif.WB_CUST_ID = wbCustId
                    if (!self.WB_ModelingSession.usesFinishedProducts) aNewRow.cif.WB_PRDGRP_ID = wbProdId
                    else aNewRow.cif.WB_PROD_ID = wbProdId
                    aNewRow.cif.WB_MODELING_SESSION_ID = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
                    aNewRow.cif.NEUTRALIZED_IND = "0"

                    self.dbContext.add(esWB_Modeling_Session_TermR, aNewRow)
                    resolve(aNewRow)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeModelingSessionTermR(aWB_MODELING_SESSION_TERMR_ID: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionTermRRows,
                (aTermRRow: WB_ModelingSessionTermRRow) => {
                    if (
                        aTermRRow.isActive &&
                        aTermRRow.cif.WB_MODELING_SESSION_TERMR_ID == aWB_MODELING_SESSION_TERMR_ID
                    ) {
                        aTermRRow.markDeleted()
                    }
                }
            )

            resolve()
        })
    }

    //</editor-fold>

    //<editor-fold desc = "Modeling Session Coeff Rule operations">

    addModelingSessionCoeffRuleR(aWB_MODELING_SESSION_COEFF_RULE_ID: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            // Is the customer in the customer table?
            self.dbContext
                .createRecordWithKey(esWB_Modeling_Session_Coeff_RuleR)
                .then((aNewRow: WB_ModelingSessionCoeffRuleRRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_MODELING_SESSION_COEFF_RULE_ID = aWB_MODELING_SESSION_COEFF_RULE_ID
                    self.dbContext.add(esWB_Modeling_Session_Coeff_RuleR, aNewRow)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeModelingSessionCoeffRuleR(
        aWB_MODELING_SESSION_COEFF_RULER_ID: number,
        aWB_MODELING_SESSION_COEFF_RULE_ID: number
    ): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionCoeffRuleRows,
                (aModelSessionCoeffRuleRow: WB_ModelingSessionCoeffRuleRow) => {
                    if (
                        aModelSessionCoeffRuleRow.isActive &&
                        aModelSessionCoeffRuleRow.cif.WB_MODELING_SESSION_COEFF_RULE_ID ==
                        aWB_MODELING_SESSION_COEFF_RULE_ID
                    ) {
                        _.forEach(
                            aModelSessionCoeffRuleRow.WB_ModelingSessionCoeffRuleRRows,
                            (aModelSessionCoeffRuleRRow: WB_ModelingSessionCoeffRuleRRow) => {
                                if (
                                    aModelSessionCoeffRuleRRow.isActive &&
                                    aModelSessionCoeffRuleRRow.cif.WB_MODELING_SESSION_COEFF_RULER_ID ==
                                    aWB_MODELING_SESSION_COEFF_RULER_ID
                                ) {
                                    aModelSessionCoeffRuleRRow.markDeleted()
                                }
                            }
                        )
                    }
                }
            )

            resolve()
        })
    }

    addModelingSessionCoeffRule(opts: {
        RuleTypeId?: string;
        CoefficientId?: number;
        RuleName?: string;
        CustomerDim?: boolean;
        ProductDim?: boolean;
        [id: string]: any;
    }): Promise<void> {
        const self = this
        const createOpts = opts

        return new Promise<void>((resolve, error) => {
            //get the Coefficient Row
            self.dbContext
                .find(esWB_Model_Coefficient, createOpts.CoefficientId)
                .then((aModelCoeffRow: WB_ModelCoefficientRow) => {
                    createOpts.ModelCoefficientRow = aModelCoeffRow
                    return self.dbContext.createRecordWithKey(esWB_Modeling_Session_Coeff_Rule)
                })
                .then((aNewRow: WB_ModelingSessionCoeffRuleRow) => {
                    const newKey = aNewRow.cif.WB_MODELING_SESSION_COEFF_RULE_ID
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID
                    aNewRow.WB_ModelingSessionRow = self.drWB_ModelingSession
                    aNewRow.cif.RULE_NAME = createOpts.RuleName
                    aNewRow.cif.WB_MODEL_COEFFICIENT_ID = createOpts.CoefficientId
                    aNewRow.cif.RULE_TYPE = createOpts.RuleTypeId
                    aNewRow.cif.RULE_ID = TextUtils.padStart(newKey.toString(36), 12, "0").toUpperCase()
                    aNewRow.cif.CUSTOMER_DIM_IND = createOpts.CustomerDim ? "1" : "0"
                    aNewRow.cif.PRODUCT_DIM_IND = createOpts.ProductDim ? "1" : "0"
                    aNewRow.cif.CUSTOMER_LEVEL = self.WB_ModelingSession?.CUSTOMER_LEVEL || ""
                    aNewRow.cif.PRODUCT_LEVEL = self.WB_ModelingSession?.PRODUCT_LEVEL || ""
                    aNewRow.WB_ModelCoefficientRow = createOpts.ModelCoefficientRow
                    self.dbContext.add(esWB_Modeling_Session_Coeff_Rule, aNewRow)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeModelingSessionCoeffRule(aWB_MODELING_SESSION_COEFF_RULE_ID: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionCoeffRuleRows,
                (aModelSessionCoeffRuleRow: WB_ModelingSessionCoeffRuleRow) => {
                    if (
                        aModelSessionCoeffRuleRow.isActive &&
                        aModelSessionCoeffRuleRow.cif.WB_MODELING_SESSION_COEFF_RULE_ID ==
                        aWB_MODELING_SESSION_COEFF_RULE_ID
                    ) {
                        aModelSessionCoeffRuleRow.markDeleted()
                    }
                }
            )

            resolve()
        })
    }

    //</editor-fold>

    //<editor-fold desc = "Modeling Session Observation operations">

    addModelingSessionObservation(opts: any): Promise<WB_ModelingSessionObservationRow> {
        const self = this
        const createOpts = opts

        return new Promise<WB_ModelingSessionObservationRow>((resolve, error) => {
            self.dbContext
                .createRecordWithKey(esWB_Modeling_Session_Observation)
                .then((aNewRow: WB_ModelingSessionObservationRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID
                    aNewRow.WB_ModelingSessionRow = self.drWB_ModelingSession
                    aNewRow.cif.WB_CUST_ID = createOpts.wbCustId
                    aNewRow.cif.WB_MODEL_PREDICTOR_ID = createOpts.wbPredictorId
                    aNewRow.cif.WB_PERIOD_ID = createOpts.wbPeriodId
                    aNewRow.cif.WB_TAG_ID = createOpts.wbTagId
                    aNewRow.cif.EXCLUDE_IND = createOpts.excludedInd
                    self.dbContext.add(esWB_Modeling_Session_Observation, aNewRow)
                    resolve(aNewRow)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeModelingSessionObservation(aWB_MODELING_SESSION_OBS_ID: number): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionObservationRows,
                (aModelSessionObservationRow: WB_ModelingSessionObservationRow) => {
                    if (
                        aModelSessionObservationRow.isActive &&
                        aModelSessionObservationRow.cif.WB_MODELING_SESSION_OBS_ID == aWB_MODELING_SESSION_OBS_ID
                    ) {
                        aModelSessionObservationRow.markDeleted()
                    }
                }
            )

            resolve()
        })
    }

    //</editor-fold>

    //<editor-fold desc = "Modeling Session Tag Rule operations">

    async addModelingSessionTagRuleR(aWB_Tag_Id: number, options: any): Promise<WB_ModelingSessionTagRuleRRow> {
        const self = this
        const recordResolver = new ESRecordResolver(self.dbContext, {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        })

        const tagRow: WB_TagRow[] = <any>(
            await recordResolver.queryAllWithRelationships(esWB_Tag, {WB_TAG_ID: aWB_Tag_Id})
        )

        if (_.isEmpty(tagRow)) return undefined

        const aNewRow: WB_ModelingSessionTagRuleRRow = <any>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_Tag_RuleR)
        )

        aNewRow.setDefaults()
        aNewRow.cif.ACTIVE_IND = "0"
        aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID
        aNewRow.cif.WB_TAG_ID = aWB_Tag_Id
        aNewRow.WB_ModelingSessionRow = self.drWB_ModelingSession
        aNewRow.WB_TagRow = tagRow[0]

        self.dbContext.add(esWB_Modeling_Session_Tag_RuleR, aNewRow)

        return aNewRow
    }

    //</editor-fold>

    //<editor-fold desc = "Modeling Session Coefficient Group operations">

    get CoefficientGroupsChanged(): BehaviorSubject<ModelingSessionBO> {
        return this._CoefficientGroupsChanged
    }

    async addModelingSessionCoeffGroup(
        aWB_Id: number,
        sGrpName: string,
        sGrpType: string,
        customerLevel: string,
        productLevel: string,
        groupMetaId: string,
        options: any
    ): Promise<WB_ModelingSessionCoeffGrpRow> {
        const self = this
        const recordResolver = new ESRecordResolver(self.dbContext, {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        })

        const aNewRow: WB_ModelingSessionCoeffGrpRow = <any>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_Coeff_Grp)
        )

        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID

        if (groupMetaId == "Coefficient") aNewRow.cif.WB_MODEL_COEFFICIENT_ID = aWB_Id
        else aNewRow.cif.WB_MODEL_CONSTANT_ID = aWB_Id

        aNewRow.cif.CUSTOMER_LEVEL = customerLevel
        aNewRow.cif.PRODUCT_LEVEL = productLevel
        aNewRow.cif.GROUP_NAME = sGrpName
        aNewRow.cif.GROUP_TYPE = sGrpType
        aNewRow.cif.GROUP_META_ID = groupMetaId
        aNewRow.WB_ModelingSessionRow = self.drWB_ModelingSession

        self.dbContext.add(esWB_Modeling_Session_Coeff_Grp, aNewRow)

        self.CoefficientGroupsChanged.next(self)

        return aNewRow
    }

    async addModelingSessionCoeffGroupSet(
        aGroupRow: WB_ModelingSessionCoeffGrpRow,
        customerName: string,
        productName: string,
        options: any
    ): Promise<WB_ModelingSessionCoeffGrpStRow> {
        const self = this

        const aNewRow: WB_ModelingSessionCoeffGrpStRow = <any>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_Coeff_GrpSt)
        )

        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELING_SESSION_COEFF_GRP_ID = aGroupRow.cif.WB_MODELING_SESSION_COEFF_GRP_ID
        aNewRow.cif.CUSTOMER_NAME = customerName
        aNewRow.cif.PRODUCT_NAME = productName
        aNewRow.WB_ModelingSessionCoeffGrpRow = aGroupRow

        self.dbContext.add(esWB_Modeling_Session_Coeff_GrpSt, aNewRow)

        return aNewRow
    }

    async addModelingSessionCoeffGroupSetR(
        aGroupSetRow: WB_ModelingSessionCoeffGrpStRow,
        wbCustId: number,
        wbProdId: number,
        productType: string,
        options: any
    ): Promise<WB_ModelingSessionCoeffGrpStRRow> {
        const self = this

        const aNewRow: WB_ModelingSessionCoeffGrpStRRow = <any>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_Coeff_GrpStR)
        )

        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELING_SESSION_COEFF_GRPST_ID = aGroupSetRow.cif.WB_MODELING_SESSION_COEFF_GRPST_ID

        if (productType == "Product") {
            const productRow = await self.dbContext.find(esWB_Finished_Product, wbProdId)
            aNewRow.WB_ProductRow = productRow
            aNewRow.cif.WB_PROD_ID = wbProdId
        } else {
            const productGrpRow = await self.dbContext.find(esWB_Product_Group, wbProdId)
            aNewRow.WB_ProductGroupRow = productGrpRow
            aNewRow.cif.WB_PRDGRP_ID = wbProdId
        }

        aNewRow.cif.WB_CUST_ID = wbCustId
        aNewRow.WB_ModelingSessionCoeffGrpStRow = aGroupSetRow

        self.dbContext.add(esWB_Modeling_Session_Coeff_GrpStR, aNewRow)

        self.CoefficientGroupsChanged.next(self)

        return aNewRow
    }

    removeModelingSessionCoeffGroup(aWB_MODELING_SESSION_COEFF_GRP_ID: number, options: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionCoeffGrpRows,
                (WB_ModelingSessionCoeffGrpRow: WB_ModelingSessionCoeffGrpRow) => {
                    if (
                        WB_ModelingSessionCoeffGrpRow.isActive &&
                        WB_ModelingSessionCoeffGrpRow.cif.WB_MODELING_SESSION_COEFF_GRP_ID ==
                        aWB_MODELING_SESSION_COEFF_GRP_ID
                    ) {
                        WB_ModelingSessionCoeffGrpRow.markDeleted()
                    }
                }
            )

            self.CoefficientGroupsChanged.next(self)
            resolve()
        })
    }

    removeModelingSessionCoeffGroupSet(
        aWB_MODELING_SESSION_COEFF_GRPST_ID: number,
        aWB_MODELING_SESSION_COEFF_GRP_ID: number,
        options: any
    ): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionCoeffGrpRows,
                (WB_ModelingSessionCoeffGrpRow: WB_ModelingSessionCoeffGrpRow) => {
                    if (
                        WB_ModelingSessionCoeffGrpRow.isActive &&
                        WB_ModelingSessionCoeffGrpRow.cif.WB_MODELING_SESSION_COEFF_GRP_ID ==
                        aWB_MODELING_SESSION_COEFF_GRP_ID
                    ) {
                        _.forEach(
                            WB_ModelingSessionCoeffGrpRow.WB_ModelingSessionCoeffGrpStRows,
                            (WB_ModelingSessionCoeffGrpStRow: WB_ModelingSessionCoeffGrpStRow) => {
                                if (
                                    WB_ModelingSessionCoeffGrpStRow.isActive &&
                                    WB_ModelingSessionCoeffGrpStRow.cif.WB_MODELING_SESSION_COEFF_GRPST_ID ==
                                    aWB_MODELING_SESSION_COEFF_GRPST_ID
                                ) {
                                    WB_ModelingSessionCoeffGrpStRow.markDeleted()
                                }
                            }
                        )
                    }
                }
            )

            resolve()
        })
    }

    // remove coefficient group set row item
    removeModelingSessionCoeffGroupSetRow(
        aWB_MODELING_SESSION_COEFF_GRP_ID: number,
        aWB_MODELING_SESSION_COEFF_GRPST_ID: number,
        aWB_MODELING_SESSION_COEFF_GRPSTR_ID: number,
        options: any
    ): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionCoeffGrpRows,
                (WB_ModelingSessionCoeffGrpRow: WB_ModelingSessionCoeffGrpRow) => {
                    if (
                        WB_ModelingSessionCoeffGrpRow.isActive &&
                        WB_ModelingSessionCoeffGrpRow.cif.WB_MODELING_SESSION_COEFF_GRP_ID ==
                        aWB_MODELING_SESSION_COEFF_GRP_ID
                    ) {
                        _.forEach(
                            WB_ModelingSessionCoeffGrpRow.WB_ModelingSessionCoeffGrpStRows,
                            (WB_ModelingSessionCoeffGrpStRow: WB_ModelingSessionCoeffGrpStRow) => {
                                if (
                                    WB_ModelingSessionCoeffGrpStRow.isActive &&
                                    WB_ModelingSessionCoeffGrpStRow.cif.WB_MODELING_SESSION_COEFF_GRPST_ID ==
                                    aWB_MODELING_SESSION_COEFF_GRPST_ID
                                ) {
                                    _.forEach(
                                        WB_ModelingSessionCoeffGrpStRow.WB_ModelingSessionCoeffGrpStRRows,
                                        (WB_ModelingSessionCoeffGrpStRRow) => {
                                            if (
                                                WB_ModelingSessionCoeffGrpStRRow.cif
                                                    .WB_MODELING_SESSION_COEFF_GRPSTR_ID ==
                                                aWB_MODELING_SESSION_COEFF_GRPSTR_ID
                                            ) {
                                                WB_ModelingSessionCoeffGrpStRRow.markDeleted()
                                            }
                                        }
                                    )
                                }
                            }
                        )
                    }
                }
            )
            resolve()
        })
    }

    async addModelingSessionConstantFR(wbConstId: number, options: any): Promise<WB_ModelingSessionConstantFRRow> {
        const self = this

        const aNewRow: WB_ModelingSessionConstantFRRow = <any>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_ConstantFR)
        )

        aNewRow.setDefaults()
        aNewRow.cif.WB_MODEL_CONSTANT_ID = wbConstId
        aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID
        aNewRow.WB_ModelingSessionRow = self.drWB_ModelingSession

        self.dbContext.add(esWB_Modeling_Session_ConstantFR, aNewRow)

        return aNewRow
    }

    //</editor-fold>

    //<editor-fold desc = "Modeling Session Solver Stage operations">

    get SolverStagesChanged(): BehaviorSubject<ModelingSessionBO> {
        return this._SolverStagesChanged
    }

    async setupInitialSolverStage(): Promise<WB_ModelingSessionStageRow> {
        const self = this

        await self.OnIHaveModelLoaded

        return new Promise<WB_ModelingSessionStageRow>((resolve, error) => {
            const checkExisting = _.filter(
                self.WB_ModelingSession.WB_ModelingSessionStageRows,
                (aRow) => aRow.isActive && aRow.cif.STEP_NUMBER == 0
            )
            if (checkExisting.length == 0) {
                self.dbContext
                    .createRecordWithKey(esWB_Modeling_Session_Stage)
                    .then((aNewRow: WB_ModelingSessionStageRow) => {
                        aNewRow.setDefaults()
                        aNewRow.cif.WB_MODELING_SESSION_ID = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
                        aNewRow.cif.STEP_NUMBER = 0
                        aNewRow.cif.CALCULATE_CONSTANTS_IND = "1"

                        self.dbContext.add(esWB_Modeling_Session_Stage, aNewRow)
                        self.SolverStagesChanged.next(self)
                        resolve(aNewRow)
                    })
                    .catch((err) => {
                        error(err)
                    })
            } else {
                resolve()
            }
        })
    }

    async addModelingSessionSolverStage(): Promise<WB_ModelingSessionStageRow> {
        const self = this
        try {
            const defaultCoeffRangePolicyType: WB_ModelingSessionStageCRPMetaRow[] = await self.dbContext.findAll(
                esWB_Modeling_Session_StageCoeffRangePolicyMeta,
                {
                    where: {
                        POLICY_ID: "Copy",
                        DELETED_IND: {neq: "1"}
                    }
                }
            )
            if (defaultCoeffRangePolicyType.length === 0) {
                throw new Error("The default boundary condition policies are not available")
            }
            const defaultCoeffRangePolicyTypeId =
                _.first(defaultCoeffRangePolicyType).cif.WB_MODELING_SESSION_STAGECRP_META_ID

            const aStageCRPRow: WB_ModelingSessionStageCRPRow = <WB_ModelingSessionStageCRPRow>(
                await self.dbContext.createRecordWithKey(esWB_Modeling_Session_StageCoeffRangePolicy)
            )
            aStageCRPRow.setDefaults()
            aStageCRPRow.StagePolicy = "Previous"
            aStageCRPRow.cif.WB_MODELING_SESSION_STAGECRP_META_ID = defaultCoeffRangePolicyTypeId
            self.dbContext.add(esWB_Modeling_Session_StageCoeffRangePolicy, aStageCRPRow)

            const solverStages = _.filter(self.WB_ModelingSession.WB_ModelingSessionStageRows, (aRow) => aRow.isActive)
            const maxStepCount = _.maxBy(solverStages, (aRow) => aRow.cif.STEP_NUMBER).cif.STEP_NUMBER
            const aStageRow: WB_ModelingSessionStageRow = <WB_ModelingSessionStageRow>(
                await self.dbContext.createRecordWithKey(esWB_Modeling_Session_Stage)
            )
            aStageRow.setDefaults()
            aStageRow.cif.WB_MODELING_SESSION_ID = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
            aStageRow.cif.STEP_NUMBER = maxStepCount + 1
            aStageRow.cif.CORE_TERMS_SOLVE_IND = "1"
            aStageRow.cif.WB_MODELING_SESSION_STAGECRP_ID = aStageCRPRow.cif.WB_MODELING_SESSION_STAGECRP_ID
            self.dbContext.add(esWB_Modeling_Session_Stage, aStageRow)

            await self.addSolverStageAlgorithm(aStageRow, "LeapFrog")

            await self.addSolverCRPRRows(aStageCRPRow)
            self.SolverStagesChanged.next(self)
            return aStageRow
        } catch (e: unknown) {
            if (e instanceof Error) {
                throw new Error(`Unable to create stage: ${e.message}`)
            }
            throw new Error(`Unknown error when creating solver stage: ${e}`)
        }
    }

    async removeModelingSessionSolverStage(aWB_MODELING_SESSION_STAGE_ID: number): Promise<void> {
        for (const stage of this.drWB_ModelingSession.WB_ModelingSessionStageRows) {
            if (!stage.isActive || stage.cif.WB_MODELING_SESSION_STAGE_ID !== aWB_MODELING_SESSION_STAGE_ID) {
                continue
            }
            stage.markDeleted()
            stage.WB_ModelingSessionStageARRows.forEach((item) => item.markDeleted())
            stage.WB_ModelingSessionStageCRPRow.WB_ModelingSessionStageCRPRRows.forEach((item) => item.markDeleted())
        }
        this.SolverStagesChanged.next(this)
    }

    //</editor-fold>

    //<editor-fold desc = "Modeling Session Solver Stage CRPR">

    /** Creates any required coefficient range policy relationship records that will specify the scale factors applied to core terms or cannibalization type coefficients */
    private async addSolverCRPRRows(coeffRangePolicyRow: WB_ModelingSessionStageCRPRow): Promise<void> {
        const self = this

        const alreadyCreated = (isCoreTerm: boolean, termOrCannTypeId: number) =>
            coeffRangePolicyRow.WB_ModelingSessionStageCRPRRows.some((item) =>
                isCoreTerm
                    ? item.cif.WB_MODEL_TERM_ID === termOrCannTypeId
                    : item.cif.WB_MODEL_CANNIBALIZATIONM_ID === termOrCannTypeId
            )

        // otherwise, they must be created for every term and every cannibalization type in the model
        const modelTerms = _.filter(self.Model.WB_Model.WB_ModelTermRelationshipRows, (aTerm) => aTerm.isActive)

        for (const x of modelTerms) {
            if (alreadyCreated(true, x.cif.WB_MODEL_TERM_ID)) {
                continue
            }

            let aNewRow: WB_ModelingSessionStageCRPRRow = <any>(
                await self.dbContext.createRecordWithKey(esWB_Modeling_Session_StageCoeffRangePolicyR)
            )
            aNewRow.setDefaults()
            aNewRow.cif.WB_MODELING_SESSION_STAGECRP_ID = coeffRangePolicyRow.cif.WB_MODELING_SESSION_STAGECRP_ID
            aNewRow.WB_ModelingSessionStageCRPRow = coeffRangePolicyRow
            aNewRow.cif.WB_MODEL_TERM_ID = x.cif.WB_MODEL_TERM_ID
            aNewRow.WB_ModelTermRow = x.WB_ModelTermRow
            self.dbContext.add(esWB_Modeling_Session_StageCoeffRangePolicyR, aNewRow)
        }

        const cannTypes = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows,
            (aCann) => aCann.isActive
        )

        for (const y of cannTypes) {
            if (alreadyCreated(false, y.cif.WB_MODEL_CANNIBALIZATIONM_ID)) {
                continue
            }

            let aNewRow: WB_ModelingSessionStageCRPRRow = <any>(
                await self.dbContext.createRecordWithKey(esWB_Modeling_Session_StageCoeffRangePolicyR)
            )
            aNewRow.setDefaults()
            aNewRow.cif.WB_MODELING_SESSION_STAGECRP_ID = coeffRangePolicyRow.cif.WB_MODELING_SESSION_STAGECRP_ID
            aNewRow.WB_ModelingSessionStageCRPRow = coeffRangePolicyRow
            aNewRow.cif.WB_MODEL_CANNIBALIZATIONM_ID = y.cif.WB_MODEL_CANNIBALIZATIONM_ID
            aNewRow.WB_ModelCannibalizationTypeRow = y.WB_ModelCannibalizationTypeRow
            self.dbContext.add(esWB_Modeling_Session_StageCoeffRangePolicyR, aNewRow)
        }
    }

    //</editor-fold>

    /** Creates a WB_ModelingSessionStageARRow (which sets the algorithm(s) that will be used to solve a stage) with the given algorithm and adds the new record to the BO's dbContext*/
    async addSolverStageAlgorithm(
        stage: WB_ModelingSessionStageRow,
        ...algorithmIds: string[]
    ): Promise<WB_ModelingSessionStageARRow[]> {
        if (algorithmIds.length === 0) {
            return []
        }

        const self = this
        const retVal: WB_ModelingSessionStageARRow[] = []
        try {
            for (const anAlg of algorithmIds) {
                const newRecord = <WB_ModelingSessionStageARRow>(
                    await this.dbContext.createRecordWithKey(esWB_Modeling_Session_StageAlgorithm)
                )
                newRecord.setDefaults()
                newRecord.WB_ModelingSessionStageRow = stage
                newRecord.cif.WB_MODELING_SESSION_STAGE_ID = stage.cif.WB_MODELING_SESSION_STAGE_ID
                newRecord.cif.ALGORITHM_ID = anAlg
                self.dbContext.add(esWB_Modeling_Session_StageAlgorithm, newRecord)
                retVal.push(newRecord)
            }
            return retVal
        } catch (e: unknown) {
            if (e instanceof Error) {
                throw new Error(`Unable to save algorithm settings: ${e.message}`)
            }
            throw new Error(`Unknown error when creating algorithm settings: ${e}`)
        }
    }

    //<editor-fold desc = "Modeling Session Solver Stage Algorithms">

    removeSolverStageAlgorithm(
        aWB_MODELING_SESSION_STAGE_ID: number,
        aWB_MODELING_SESSION_STAGEAR_ID: number
    ): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(
                self.drWB_ModelingSession.WB_ModelingSessionStageRows,
                (aStageRow: WB_ModelingSessionStageRow) => {
                    if (
                        aStageRow.isActive &&
                        aStageRow.cif.WB_MODELING_SESSION_STAGE_ID == aWB_MODELING_SESSION_STAGE_ID
                    ) {
                        let stageARRow = _.first(
                            _.filter(
                                aStageRow.WB_ModelingSessionStageARRows,
                                (aStageARRow: WB_ModelingSessionStageARRow) =>
                                    aStageARRow.isActive &&
                                    aStageARRow.cif.WB_MODELING_SESSION_STAGEAR_ID == aWB_MODELING_SESSION_STAGEAR_ID
                            )
                        )
                        if (stageARRow) {
                            stageARRow.markDeleted()
                        }
                    }
                }
            )

            resolve()
        })
    }

    //</editor-fold>

    //<editor-fold desc="IHaveModel Operations">

    private _Model: ModelBO
    private _OnIHaveModelLoaded: Promise<void>
    private _bIHaveModelLoaded: boolean

    IHaveModel_init() {
        this._bIHaveModelLoaded = false
        this._OnIHaveModelLoaded = undefined
        this._Model = undefined
    }

    IHaveModel_BeforeReload() {
        this._bIHaveModelLoaded = false
        this._OnIHaveModelLoaded = undefined
    }

    get bIHaveModelLoaded(): boolean {
        return this._bIHaveModelLoaded
    }

    get OnIHaveModelLoaded(): Promise<void> {
        const self = this

        if (self._OnIHaveModelLoaded) return self._OnIHaveModelLoaded

        const returnValue = (self._OnIHaveModelLoaded = new Promise<void>((resolve, error) => {
            const wbModelId = self.WB_ModelingSession.cif.WB_MODEL_ID
            if (!(wbModelId > 0)) {
                error(`No Model Specified: ${wbModelId}`)
                return
            }
            const aModel = new ModelBO()
            aModel
                .Load(wbModelId, {dbContext: self.dbContext})
                .then((ignore) => {
                    self._Model = aModel
                    self._bIHaveModelLoaded = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        }))

        return returnValue
    }

    get Model(): ModelBO {
        return this._Model
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveSourceCustomers operations">

    SourceCustomersChanged: BehaviorSubject<IHaveSourceCustomers>

    _bAllSourceCustomersLoaded: boolean
    _AllSourceCustomers: WB_CustomerRow[]
    _OnIHaveSourceCustomersLoaded: Promise<IHaveSourceCustomers>
    _loadedDataSourceICst: WB_ModelDataSourceRow

    IHaveSourceCustomers_init(): void {
        this.SourceCustomersChanged = new BehaviorSubject<IHaveSourceCustomers>(this)
        this._AllSourceCustomers = []
        this._bAllSourceCustomersLoaded = false
        this._OnIHaveSourceCustomersLoaded = undefined
        this._loadedDataSourceICst = undefined
    }

    IHaveSourceCustomers_BeforeReload(): void {
        this._AllSourceCustomers = []
        this._bAllSourceCustomersLoaded = false
        this._OnIHaveSourceCustomersLoaded = undefined
        this._loadedDataSourceICst = undefined
    }

    get SourceCustomersReadOnly(): boolean {
        if (this._bIsDeleted) {
            return true
        }

        return false
    }

    async addSourceCustomer(aWB_CUST_ID: number): Promise<void> {
        const self = this

        let bFound = false
        _.filter(self.drWB_ModelingSession.WB_ModelingSessionCustRRows, (aCustRRow: WB_ModelingSessionCustRRow) => {
            if (aCustRRow.isActive && aCustRRow.cif.WB_CUST_ID == aWB_CUST_ID) {
                bFound = true
                return
            }
        })
        if (bFound)
            return


        // Is the custr in the modeling session  table?
        const aCustRRecord = await self.dbContext.find(esWB_Customer, aWB_CUST_ID)

        if (!aCustRRecord) return

        // create new records
        const aNewRow: WB_ModelingSessionCustRRow = <WB_ModelingSessionCustRRow>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_CustR)
        )

        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELING_SESSION_ID = self.drWB_ModelingSession.cif.WB_MODELING_SESSION_ID
        aNewRow.cif.WB_CUST_ID = aWB_CUST_ID
        aNewRow.WB_CustomerRow = aCustRRecord
        self.dbContext.add(esWB_Modeling_Session_CustR, aNewRow)
        self.SourceCustomersChanged.next(self)
        self.DataScopeChanged.next({
            ModelingSessionBO: self,
            Row: self.drWB_ModelingSession,
            PropertyChanged: "Customer",
            PropertyValue: "Add"
        })
    }

    async removeSourceCustomer(aWB_CUST_ID: number): Promise<void> {
        const self = this

        _.forEach(self.drWB_ModelingSession.WB_ModelingSessionCustRRows, (aCustRRow: WB_ModelingSessionCustRRow) => {
            if (aCustRRow.isActive && aCustRRow.cif.WB_CUST_ID == aWB_CUST_ID) {
                aCustRRow.markDeleted()
            }
        })

        self.SourceCustomersChanged.next(self)
        self.DataScopeChanged.next({
            ModelingSessionBO: self,
            Row: self.drWB_ModelingSession,
            PropertyChanged: "Customer",
            PropertyValue: "Remove"
        })
    }

    hasSourceCustomer(SourceCustomerId: number): boolean {
        let returnValue = false

        _.forEach(this.WB_ModelingSession.WB_ModelingSessionCustRRows, (aRelRow) => {
            if (aRelRow.isActive && aRelRow.WB_CustomerRow) {
                if (aRelRow.WB_CustomerRow.cif.WB_CUST_ID == SourceCustomerId) {
                    returnValue = true
                    return false // stop iterating
                }
            }
        })
        return returnValue
    }

    hasModelConstants(): boolean {
        let returnValue = false

        const modelTerms = _.filter(
            this.WB_ModelingSession.WB_ModelRow.WB_ModelTermRelationshipRows,
            (aMTRow: WB_ModelTermRelationshipRow) => aMTRow.isActive
        )
        const modelTermRows = _.map(modelTerms, (aTerm: WB_ModelTermRelationshipRow) => aTerm.WB_ModelTermRow)

        _.forEach(modelTermRows, (aTermRow) => {
            if (
                aTermRow.isActive &&
                (aTermRow.cif.WB_MODEL_CONSTANT_ID !== 0 ||
                    aTermRow.cif.WB_MODEL_CONSTANT_ID2 !== 0 ||
                    aTermRow.cif.WB_MODEL_CONSTANT_ID3 !== 0 ||
                    aTermRow.cif.WB_MODEL_CONSTANT_ID4 !== 0)
            ) {
                returnValue = true
                return false
            }
        })
        return returnValue
    }

    isSourceCustomerEditable(SourceCustomerId: number): boolean {
        return true
    }

    get bIHaveSourceCustomersLoaded(): boolean {
        return this._bAllSourceCustomersLoaded
    }

    get SourceCustomers(): WB_CustomerRow[] {
        const returnValue: WB_CustomerRow[] = []

        _.forEach(this.WB_ModelingSession.WB_ModelingSessionCustRRows, (aRelRow) => {
            if (aRelRow.isActive && aRelRow.WB_CustomerRow) {
                returnValue.push(aRelRow.WB_CustomerRow)
            }
        })
        return returnValue
    }

    get AllSourceCustomers(): WB_CustomerRow[] {
        return this._AllSourceCustomers
    }

    get OnIHaveSourceCustomersLoaded(): Promise<IHaveSourceCustomers> {
        const self = this

        if (self._bAllSourceCustomersLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveSourceCustomersLoaded)) return self._OnIHaveSourceCustomersLoaded // Load already started, wait on same Promise

        const returnValue = (self._OnIHaveSourceCustomersLoaded = (async () => {
            // If the BO is not loaded, throw an error.. It should have been started
            await self.OnAllSourceCustomersLoaded_ReloadAll()
            self._bAllSourceCustomersLoaded = true
            return self
        })())

        return returnValue
    }

    async OnAllSourceCustomersLoaded_ReloadAll(): Promise<void> {
        const self = this

        if (
            self._loadedDataSourceICst &&
            self._loadedDataSourceICst?.cif?.WB_MODEL_DATASOURCE_ID ==
            self.WB_ModelingSession?.WB_ModelRow?.cif?.WB_MODEL_DATASOURCE_ID
        )
            return

        await self.OnIHaveModelLoaded

        if (!self.Model) return

        const drModel = self.Model.WB_Model

        if (!(self.drWB_ModelingSession.cif.WB_CUSTH_ID > 0)) return

        const wbDataSourceId = self.WB_ModelingSession?.WB_ModelRow?.cif?.WB_MODEL_DATASOURCE_ID
        if (!(wbDataSourceId > 0)) return

        const drDataSourceRow: WB_ModelDataSourceRow = await self.dbContext.find(esWB_Model_DataSource, wbDataSourceId)
        if (_.isEmpty(drDataSourceRow)) return

        self._loadedDataSourceICst = drDataSourceRow

        //  Determine the distinct keys of the Data Source
        if (!drDataSourceRow) {
            self._AllSourceCustomers = []
            return
        }
        const entityName = drDataSourceRow.cif.TARGET_TABLENAME.replace("/AZR/", "")
        let arrKeys = await PASearch.findByRequest({
            distinct: [drDataSourceRow.cif.CUSTOMER_FIELDNAME],
            model: entityName,
            fields: {[drDataSourceRow.cif.CUSTOMER_FIELDNAME]: {type: "number"}}
        })

        arrKeys = _.map(arrKeys, (a) => a[drDataSourceRow.cif.CUSTOMER_FIELDNAME])

        if (arrKeys.length == 0) {
            self._AllSourceCustomers = []
            return
        }

        // Determine Target Keys
        const endDate = self.WB_ModelingSession.SessionDate.Range.EndDt

        const dsEntity = await EntityTypeUtils.getEntityTypeRowByLogicalKey(
            self.drWB_ModelingSession.cif.WB_MDSET_ID,
            "Customer",
            drDataSourceRow.cif.ENTITY_ID_CUSTOMER
        )

        if (!dsEntity) {
            self._AllSourceCustomers = []
            console.error(
                `Could not find datasource customer entity with Entity Type ID ${drDataSourceRow.cif.ENTITY_ID_CUSTOMER}`
            )
            return
        }

        if (dsEntity.cif.WB_ENTITY_ID != self.drWB_ModelingSession.cif.WB_ENTITY_ID_CUSTOMER) {
            // find the entity type for the datasource customer
            const parentIds: Set<number> = new Set()
            for (const wbCstId of arrKeys) {
                if (wbCstId > 0) {
                    const wbCstIdParent = await CustomerHierarchyService.getEntityTransformation(
                        self.drWB_ModelingSession.cif.WB_CUSTH_ID,
                        self.drWB_ModelingSession.cif.WB_SALESORG_ID,
                        dsEntity.cif.WB_ENTITY_ID,
                        self.drWB_ModelingSession.cif.WB_ENTITY_ID_CUSTOMER,
                        wbCstId,
                        endDate
                    )
                    wbCstIdParent.filter((a) => a > 0).forEach((a) => parentIds.add(a))
                }
            }
            arrKeys = Array.from(parentIds)
        }

        arrKeys = _.map(
            <WB_ProductGroupRow[]>await self.dbContext.findAll(esWB_Customer_Relationship, {
                where: {
                    WB_CUST_ID: {inq: arrKeys},
                    WB_CUSTH_ID: self.drWB_ModelingSession.cif.WB_CUSTH_ID,
                    DELETED_IND: {neq: "1"}
                }
            }),
            "WB_CUST_ID"
        )

        const allCusts = <WB_CustomerRow[]>await self.dbContext.findUsingCache(esWB_Customer, arrKeys)

        self._AllSourceCustomers = allCusts
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveProductGroup operations">

    _bIHaveProductGroupsLoaded: boolean
    _OnIHaveProductGroupsLoaded: Promise<IHaveProductGroups>
    _loadedDataSourceIPG: WB_ModelDataSourceRow
    _allProductGroups: WB_ProductGroupRow[]

    IHaveProductGroups_init() {
        this.ProductGroupsChanged = new BehaviorSubject<IHaveProductGroups>(this)
        this._bIHaveProductGroupsLoaded = false
        this._OnIHaveProductGroupsLoaded = undefined
        this._loadedDataSourceIPG = undefined
        this._allProductGroups = []
    }

    IHaveProductGroups_BeforeReload() {
        this._bIHaveProductGroupsLoaded = false
        this._OnIHaveProductGroupsLoaded = undefined
        this._loadedDataSourceIPG = undefined
        this._allProductGroups = []
    }

    ProductGroupsChanged: BehaviorSubject<IHaveProductGroups>

    get bIHaveProductGroupsLoaded(): boolean {
        return this._bIHaveProductGroupsLoaded
    }

    get OnIHaveProductGroupsLoaded(): Promise<IHaveProductGroups> {
        const self = this

        if (self._OnIHaveProductGroupsLoaded) {
            return Promise.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveProductGroupsLoaded)) return self._OnIHaveProductGroupsLoaded // Load already started, wait on same Promise

        const returnValue = (self._OnIHaveProductGroupsLoaded = (async () => {
            await self.OnIHaveProductGroups_ReloadAll()
            self._bIHaveProductGroupsLoaded = true
            return self
        })())

        return returnValue
    }

    private async OnIHaveProductGroups_ReloadAll(bForce?: boolean): Promise<void> {
        const self = this

        if (_.includes(["FinishedProduct", "ConsumerProduct"], self.WB_ModelingSession.PRODUCT_LEVEL)) return

        if (
            self._loadedDataSourceIPG &&
            self._loadedDataSourceIPG?.cif?.WB_MODEL_DATASOURCE_ID ==
            self.WB_ModelingSession?.WB_ModelRow?.cif?.WB_MODEL_DATASOURCE_ID
        )
            return

        await self.OnIHaveModelLoaded

        if (!self.Model) return

        const drModel = self.Model.WB_Model

        if (!(self.drWB_ModelingSession.cif.WB_PRDH_ID > 0)) return

        const prdHId: number = self.drWB_ModelingSession.cif.WB_PRDH_ID
        const prdHRow: WB_ProductHierarchyRow = await self.dbContext.find(esWB_Product_Hierarchy, prdHId)
        const prdMDSetId: number = prdHRow.cif.WB_MDSET_ID

        const wbDataSourceId = self.WB_ModelingSession?.WB_ModelRow?.cif?.WB_MODEL_DATASOURCE_ID
        if (!(wbDataSourceId > 0)) return

        const drDataSourceRow: WB_ModelDataSourceRow = await self.dbContext.find(esWB_Model_DataSource, wbDataSourceId)
        if (_.isEmpty(drDataSourceRow)) return

        self._loadedDataSourceIPG = drDataSourceRow

        //  Determine the distinct keys of the Data Source
        const entityName = drDataSourceRow.cif.TARGET_TABLENAME.replace("/AZR/", "")
        let arrKeys = await PASearch.findByRequest({
            distinct: [drDataSourceRow.cif.PRODUCT_FIELDNAME],
            model: entityName,
            fields: {[drDataSourceRow.cif.PRODUCT_FIELDNAME]: {type: "number"}}
        })

        arrKeys = _.map(arrKeys, (a) => a[drDataSourceRow.cif.PRODUCT_FIELDNAME])
        let allPrdGrps: WB_ProductGroupRow[] = []
        // Determine Target Keys
        const startDate = self.WB_ModelingSession.SessionDate.Range.StartDt
        const endDate = self.WB_ModelingSession.SessionDate.Range.EndDt

        if (drDataSourceRow.cif.ENTITY_ID_PRODUCT != self.drWB_ModelingSession.PRODUCT_LEVEL) {
            const dctParentResults: { [id: number]: number } = {}
            if (["FinishedProduct", "ConsumerProduct"].includes(drDataSourceRow.cif.ENTITY_ID_PRODUCT)) {
                for (const wbPrdId of arrKeys) {
                    if (wbPrdId > 0) {
                        const wbPrdIdParent = await ProductHierarchyService.getProductParent(
                            self.drWB_ModelingSession.cif.WB_PRDH_ID,
                            wbPrdId,
                            startDate,
                            endDate,
                            self.drWB_ModelingSession.PRODUCT_LEVEL
                        )
                        if (wbPrdIdParent > 0) {
                            dctParentResults[wbPrdIdParent] = wbPrdIdParent
                        }
                    }
                }
            } else {
                for (const wbPrdId of arrKeys) {
                    if (wbPrdId > 0) {
                        const wbPrdIdParent = await ProductHierarchyService.getPrdGrpParent(
                            self.drWB_ModelingSession.cif.WB_PRDH_ID,
                            wbPrdId,
                            startDate,
                            endDate,
                            self.drWB_ModelingSession.PRODUCT_LEVEL
                        )
                        if (wbPrdIdParent > 0) {
                            dctParentResults[wbPrdIdParent] = wbPrdIdParent
                        }
                    }
                }
            }
            arrKeys = _.keys(dctParentResults)
            allPrdGrps = <WB_ProductGroupRow[]>await self.dbContext.findUsingCache(esWB_Product_Group, arrKeys)
        } else {
            arrKeys = _.map(
                <WB_ProductGroupRow[]>await self.dbContext.findAll(esWB_Product_Group_Relationship, {
                    where: {
                        WB_PRDGRP_ID: {inq: arrKeys},
                        WB_PRDH_ID: self.drWB_ModelingSession.cif.WB_PRDH_ID,
                        DELETED_IND: {neq: "1"}
                    }
                }),
                "WB_PRDGRP_ID"
            )
            allPrdGrps = <WB_ProductGroupRow[]>await self.dbContext.findUsingCache(esWB_Product_Group, arrKeys)
            // Filter results in case view isn't really at the level the datasource metadata says..
            allPrdGrps = _.filter(allPrdGrps, (aPG) => aPG.cif.LEVEL_ID == self.drWB_ModelingSession.PRODUCT_LEVEL)
        }

        //filter products based on the MasterDataSet ID of the Model's Product Hierarchy
        allPrdGrps = _.filter(allPrdGrps, (aPrd) => aPrd.cif.WB_MDSET_ID == prdMDSetId)
        self._allProductGroups = allPrdGrps
    }

    get ProductGroups(): WB_ProductGroupRow[] {
        const prdGrps = _.map(
            _.filter(this.WB_ModelingSession.WB_ModelingSessionProdRRows, (a: WB_ModelingSessionProdRRow) => a.isActive && a.WB_ProductGroupRow),
            (b: WB_ModelingSessionProdRRow) => b.WB_ProductGroupRow
        )
        return prdGrps
    }

    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._allProductGroups
    }

    get ProductGroupsReadOnly(): boolean {
        return false
    }

    async addProductGroup(ProductGroupId: number): Promise<void> {
        const self = this

        const aWbId = _.toNumber(ProductGroupId)
        if (!_.isNumber(aWbId)) return

        const a = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionProdRRows,
            (a) => a.isActive && a.cif.WB_PRDGRP_ID == aWbId
        )
        if (a.length > 0) return

        const prdGrpRow = await self.dbContext.find(esWB_Product_Group, aWbId)

        const newRow: WB_ModelingSessionProdRRow = <WB_ModelingSessionProdRRow>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_ProdR)
        )
        newRow.setDefaults()
        newRow.cif.WB_MODELING_SESSION_ID = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID

        if (!_.isEmpty(prdGrpRow)) newRow.cif.WB_PRDGRP_ID = aWbId
        else newRow.cif.WB_PROD_ID = aWbId

        self.dbContext.add(esWB_Modeling_Session_ProdR, newRow)
        self.ProductGroupsChanged.next(self)
        self.DataScopeChanged.next({
            ModelingSessionBO: self,
            Row: self.drWB_ModelingSession,
            PropertyChanged: "Product",
            PropertyValue: "Add"
        })
    }

    async removeProductGroup(ProductGroupId: number): Promise<void> {
        const self = this

        const aWbId = _.toNumber(ProductGroupId)
        if (!_.isNumber(aWbId)) return

        const arr = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionProdRRows,
            (a) => a.isActive && a.cif.WB_PRDGRP_ID == aWbId
        )
        _.forEach(arr, (aRow) => {
            aRow.markDeleted()
        })

        self.ProductGroupsChanged.next(self)
        self.DataScopeChanged.next({
            ModelingSessionBO: self,
            Row: self.drWB_ModelingSession,
            PropertyChanged: "Product",
            PropertyValue: "Remove"
        })
    }

    hasProductGroup(ProductGroupId: number): boolean {
        const self = this

        const aWbId = _.toNumber(ProductGroupId)
        if (!_.isNumber(aWbId)) return false

        const arr = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionProdRRows,
            (a) => a.isActive && a.cif.WB_PRDGRP_ID == aWbId
        )

        return arr.length > 0
    }

    isProductGroupEditable(ProductGroupId: number): boolean {
        return true
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveFinishedProducts operations">

    _bIHaveFinishedProductsLoaded: boolean
    _OnIHaveFinishedProductsLoaded: Promise<IHaveFinishedProducts>
    _loadedDataSourceIProd: WB_ModelDataSourceRow
    _allFinishedProducts: WB_FinishedProductRow[]

    IHaveFinishedProducts_init() {
        this.FinishedProductsChanged = new BehaviorSubject<IHaveFinishedProducts>(this)
        this._bIHaveFinishedProductsLoaded = false
        this._OnIHaveFinishedProductsLoaded = undefined
        this._loadedDataSourceIPG = undefined
        this._allFinishedProducts = []
    }

    IHaveFinishedProducts_BeforeReload() {
        this._bIHaveFinishedProductsLoaded = false
        this._OnIHaveFinishedProductsLoaded = undefined
        this._loadedDataSourceIPG = undefined
        this._allFinishedProducts = []
    }

    FinishedProductsChanged: BehaviorSubject<IHaveFinishedProducts>

    get bIHaveFinishedProductsLoaded(): boolean {
        return this._bIHaveFinishedProductsLoaded
    }

    get OnIHaveFinishedProductsLoaded(): Promise<IHaveFinishedProducts> {
        const self = this

        if (self._OnIHaveFinishedProductsLoaded) {
            return Promise.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveFinishedProductsLoaded)) return self._OnIHaveFinishedProductsLoaded // Load already started, wait on same Promise

        const returnValue = (self._OnIHaveFinishedProductsLoaded = (async () => {
            await self.OnIHaveFinishedProducts_ReloadAll()
            self._bIHaveFinishedProductsLoaded = true
            return self
        })())

        return returnValue
    }

    private async OnIHaveFinishedProducts_ReloadAll(bForce?: boolean): Promise<void> {
        const self = this
        if (!_.includes(["FinishedProduct", "ConsumerProduct"], self.WB_ModelingSession.PRODUCT_LEVEL)) return

        if (
            self._loadedDataSourceIProd &&
            self._loadedDataSourceIProd?.cif?.WB_MODEL_DATASOURCE_ID ==
            self.WB_ModelingSession?.WB_ModelRow?.cif?.WB_MODEL_DATASOURCE_ID
        )
            return

        await self.OnIHaveModelLoaded

        if (!self.Model) return

        if (!(self.WB_ModelingSession.cif.WB_PRDH_ID > 0)) return

        const wbDataSourceId = self.WB_ModelingSession?.WB_ModelRow?.cif?.WB_MODEL_DATASOURCE_ID
        if (!(wbDataSourceId > 0)) return

        const drDataSourceRow: WB_ModelDataSourceRow = await self.dbContext.find(esWB_Model_DataSource, wbDataSourceId)
        if (_.isEmpty(drDataSourceRow)) return

        self._loadedDataSourceIProd = drDataSourceRow

        //  Determine the distinct keys of the Data Source
        const entityName = drDataSourceRow.cif.TARGET_TABLENAME.replace("/AZR/", "")
        let arrKeys = await PASearch.findByRequest({
            distinct: [drDataSourceRow.cif.PRODUCT_FIELDNAME],
            model: entityName,
            fields: {[drDataSourceRow.cif.PRODUCT_FIELDNAME]: {type: "number"}}
        })

        arrKeys = _.map(arrKeys, (a) => a[drDataSourceRow.cif.PRODUCT_FIELDNAME])
        arrKeys = _.map(
            <WB_FinishedProductRelationshipRow[]>await self.dbContext.findAll(esWB_Finished_Product_Relationship, {
                where: {
                    WB_PROD_ID: {inq: arrKeys},
                    WB_PRDH_ID: self.drWB_ModelingSession.cif.WB_PRDH_ID,
                    DELETED_IND: {neq: "1"}
                }
            }),
            "WB_PROD_ID"
        )

        const allProducts = <WB_FinishedProductRow[]>(
            await self.dbContext.findUsingCache(esWB_Finished_Product, arrKeys)
        )
        self._allFinishedProducts = allProducts
    }

    get FinishedProducts(): WB_FinishedProductRow[] {
        const prods = _.map(
            _.filter(this.WB_ModelingSession.WB_ModelingSessionProdRRows, (a: WB_ModelingSessionProdRRow) => a.isActive && a.WB_ProductRow),
            (b: WB_ModelingSessionProdRRow) => b.WB_ProductRow
        )
        return prods
    }

    get AllFinishedProducts(): WB_FinishedProductRow[] {
        return this._allFinishedProducts
    }

    get FinishedProductsReadOnly(): boolean {
        return false
    }

    async addFinishedProduct(ProductId: number): Promise<void> {
        const self = this

        const aWbId = _.toNumber(ProductId)
        if (!_.isNumber(aWbId)) return

        const a = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionProdRRows,
            (a) => a.isActive && a.cif.WB_PROD_ID == aWbId
        )
        if (a.length > 0) return

        const prodRow = await self.dbContext.find(esWB_Finished_Product, aWbId)

        const newRow: WB_ModelingSessionProdRRow = <WB_ModelingSessionProdRRow>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_ProdR)
        )
        newRow.setDefaults()
        newRow.cif.WB_MODELING_SESSION_ID = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID

        newRow.cif.WB_PROD_ID = aWbId

        self.dbContext.add(esWB_Modeling_Session_ProdR, newRow)
        self.FinishedProductsChanged.next(self)
    }

    async removeFinishedProduct(ProductId: number): Promise<void> {
        const self = this

        const aWbId = _.toNumber(ProductId)
        if (!_.isNumber(aWbId)) return

        const arr = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionProdRRows,
            (a) => a.isActive && a.cif.WB_PROD_ID == aWbId
        )
        _.forEach(arr, (aRow) => {
            aRow.markDeleted()
        })

        self.FinishedProductsChanged.next(self)
    }

    /*hasProductGroup(ProductGroupId: number): boolean {
        const self = this

        let aWbId = _.toNumber(ProductGroupId)
        if (!_.isNumber(aWbId))
            return false

        let arr = _.filter(self.WB_ModelingSession.WB_ModelingSessionProdRRows, (a) => a.isActive && a.cif.WB_PRDGRP_ID == aWbId)

        return (arr.length > 0)
    }

    isProductGroupEditable(ProductGroupId: number): boolean {
        return true;
    }*/

    //</editor-fold>

    async getCustomerProductCombinations(sProductLevel: string): Promise<any> {
        const self = this

        const productLevel = self.WB_ModelingSession.PRODUCT_LEVEL

        //get Customers
        const customerRows = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionCustRRows,
            (aMDCRow: WB_ModelingSessionCustRRow) => aMDCRow.isActive
        )
        const arrCustomerIds = _.map(customerRows, (aCustRRow: WB_ModelingSessionCustRRow) => aCustRRow.cif.WB_CUST_ID)

        //get modeling session products
        const productRows = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionProdRRows,
            (aMDPRow: WB_ModelingSessionProdRRow) => aMDPRow.isActive
        )
        let arrProductIds: number[] = []

        if (productLevel == "FinishedProduct" || productLevel == "ConsumerProduct") {
            arrProductIds = _.map(productRows, (aProdRRow: WB_ModelingSessionProdRRow) => aProdRRow.cif.WB_PROD_ID)
        } else {
            arrProductIds = _.map(productRows, (aProdRRow: WB_ModelingSessionProdRRow) => aProdRRow.cif.WB_PRDGRP_ID)
        }

        let finalProductIds: number[] = []

        if (sProductLevel == productLevel) {
            finalProductIds = arrProductIds
        } else {
            const startDate = self.WB_ModelingSession.SessionDate.Range.StartDt
            const endDate = self.WB_ModelingSession.SessionDate.Range.EndDt
            for (const wbPrdId of arrProductIds) {
                if (wbPrdId > 0) {
                    const wbChildPrdIds: number[] = await ProductHierarchyService.getChildren(
                        self.WB_ModelingSession.cif.WB_PRDH_ID,
                        wbPrdId,
                        startDate,
                        endDate,
                        sProductLevel
                    )
                    for (const wbChildPrdId of wbChildPrdIds) {
                        finalProductIds.push(wbChildPrdId)
                    }
                }
            }
        }

        const createCombinations = (a: number[], b: number[]): number[] =>
            [].concat(...a.map((a2) => b.map((b2) => [].concat(a2, b2))))

        const custPrdGrpPairs = createCombinations(arrCustomerIds, finalProductIds)

        return custPrdGrpPairs
    }

    //<editor-fold desc = "Record Resolver operations -- static">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        const opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ("dbContext" in opts) {
            dbContext = opts.dbContext
        } else {
            dbContext = new PAdbContext({})
        }

        const modeling_session_options: CreateOptions = {
            standardConditions: {
                [esWB_Modeling_Session_Cannibalization_Type_Relationship]: {DELETED_IND: {notIn: ["1"]}},
                [esWB_Modeling_Session_AffinitySet_Relationship]: {DELETED_IND: {notIn: ["1"]}},
                [esWB_Modeling_Session_Trial]: {DELETED_IND: {notIn: ["1"]}},
                [esWB_Modeling_Session_El]: {DELETED_IND: {notIn: ["1"]}},
                [esWB_Modeling_Session_Stage]: {DELETED_IND: {neq: "1"}},
                [esWB_Modeling_Session_StageAlgorithm]: {DELETED_IND: {neq: "1"}},
                [esWB_Modeling_Session_StageCoeffRangePolicy]: {DELETED_IND: {neq: "1"}},
                [esWB_Modeling_Session_StageCoeffRangePolicyR]: {DELETED_IND: {neq: "1"}}
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_AffinitySet]: [esWB_Model_Cannibalization_Type],
                [esWB_Model_Cannibalization_Relationship]: [esWB_Model_Function],
                [esWB_Modeling_Session_Stage]: [esWB_Modeling_Session_StageCoeffRangePolicy],
                [esWB_Modeling_Session_StageCoeffRangePolicy]: [esWB_Modeling_Session_StageCoeffRangePolicyR]
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_Modeling_Session_Trial]: [
                    esWB_Modeling_Session_Trial_Metric,
                    esWB_Modeling_Session_Trial_Predictor_Metric,
                    esWB_Modeling_Session_Trial_PredictorR_Metric,
                    esWB_Modeling_Session_Trial_PartitionStage
                ]
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, modeling_session_options)

        return aRecResolver
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, error) => {
            recordResolver
                .findAllWithRelationships(esWB_Modeling_Session, ids)
                .then((result) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10
    }

    //</editor-fold>

    //<editor-fold desc="IHaveModelingSessionCalculator operations">

    private _modelingSessionCalculator: IModelingSessionCalculator

    private IHaveModelingSessionCalculator_init() {
        this._modelingSessionCalculator = new ModelingSessionCalculator()
    }

    private IHaveModelingSessionCalculator_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self._modelingSessionCalculator.Register(self)
            resolve()
        })
    }

    private IHaveModelingSessionCalculator_BeforeReload(): void {
        // Do nothing
    }

    get ModelingSessionCalculator(): IModelingSessionCalculator {
        return this._modelingSessionCalculator
    }

    //</editor-fold>

    //<editor-fold desc="Validate Policies">

    validatePolicies(): Promise<WB_ModelingSessionRefRRow[]> {
        const self = this
        return new Promise<WB_ModelingSessionRefRRow[]>((resolve, error) => {
            const modelingSessionId: number = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
            const modelService = new ModelingSessionService()

            async function executeValidatePolicies() {
                interface ICustProdPredPair {
                    WB_CUST_ID: number;
                    WB_PRDGRP_ID: number;
                    WB_MODEL_PREDICTOR_ID: number;
                }

                //Step 1: Get the list of predictors that require reference values
                const arrRefReqPredictors = await self._Model.getPredictorsRequiringRefValues()

                const arrModelPredictorRels = _.map(
                    _.filter(
                        self._Model.WB_Model.WB_ModelPredictorRelationshipRows,
                        (aModelPredRRow: WB_ModelPredictorRelationshipRow) => aModelPredRRow.isActive
                    ),
                    (aModelPredRel: WB_ModelPredictorRelationshipRow) => {
                        return aModelPredRel.WB_ModelPredictorRow
                    }
                )

                const arrPredictorsToBeAdded = _.intersection(arrRefReqPredictors, arrModelPredictorRels)

                //Step 2: Get customer-product pairs from the affinity sets
                const arrAffSetCustProdPairs: {
                    WB_CUST_ID: number;
                    WB_PRDGRP_ID: number;
                }[] = await self.getAffinitySetCustomerProductPairs({})

                //Step 3:  create a cartesian product of the affinity set cust-prod pairs and the required predictors */
                const cartesianProduct: ICustProdPredPair[] = []

                _.forEach(arrAffSetCustProdPairs, (aCustPrd) => {
                    _.forEach(arrPredictorsToBeAdded, (aPred) => {
                        cartesianProduct.push({
                            WB_CUST_ID: aCustPrd.WB_CUST_ID,
                            WB_PRDGRP_ID: aCustPrd.WB_PRDGRP_ID,
                            WB_MODEL_PREDICTOR_ID: aPred.cif.WB_MODEL_PREDICTOR_ID
                        })
                    })
                })

                //Step 4: Call CalculateReferenceValues
                try {
                    const calcRefValuesResponse: IModelingSessionServiceReferenceValuesResponse =
                        await modelService.CalculateReferenceValues(modelingSessionId, {})

                    /*let calcRefValuesResponse: IModelingSessionServiceResponse
                        = {}
                    calcRefValuesResponse.bSuccess = true*/

                    if (calcRefValuesResponse.bSuccess == false) {
                        self.ValidateMessageProvider.addMessage({
                            code: "ValidatePoliciesError",
                            type: MessageType.Information,
                            title: JSON.stringify(calcRefValuesResponse.errors),
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                        resolve([])
                        return
                    } else {
                        //Step 5: Reload the BO to get latest RefR rows
                        await self.Reload()

                        //Step 6: get RefR rows which have 0 reference values and intersect them with the affinity set - required
                        // predictor combinations
                        const arrModelingSessionRefRRows: WB_ModelingSessionRefRRow[] = _.filter(
                            self.WB_ModelingSession.WB_ModelingSessionRefRRows,
                            (aRefRRow: WB_ModelingSessionRefRRow) => aRefRRow.isActive && aRefRRow.cif.REF_VALUE == 0
                        )

                        const arrRefRCustProdPredictorPairs: ICustProdPredPair[] = _.map(
                            arrModelingSessionRefRRows,
                            (aRefRRow: WB_ModelingSessionRefRRow) => {
                                const obj = {
                                    WB_CUST_ID: aRefRRow.cif.WB_CUST_ID,
                                    WB_PRDGRP_ID: aRefRRow.cif.WB_PRDGRP_ID,
                                    WB_MODEL_PREDICTOR_ID: aRefRRow.cif.WB_MODEL_PREDICTOR_ID
                                }
                                return obj
                            }
                        )

                        const commonPairs: ICustProdPredPair[] = _.intersectionWith(
                            arrRefRCustProdPredictorPairs,
                            cartesianProduct,
                            _.isEqual
                        )

                        const exceptions: WB_ModelingSessionRefRRow[] = []
                        _.forEach(arrModelingSessionRefRRows, (aRefRRow: WB_ModelingSessionRefRRow) => {
                            _.forEach(commonPairs, (aPair: ICustProdPredPair) => {
                                if (
                                    aRefRRow.cif.WB_CUST_ID === aPair.WB_CUST_ID &&
                                    aRefRRow.cif.WB_PRDGRP_ID === aPair.WB_PRDGRP_ID &&
                                    aRefRRow.cif.WB_MODEL_PREDICTOR_ID === aPair.WB_MODEL_PREDICTOR_ID
                                )
                                    exceptions.push(aRefRRow)
                            })
                        })

                        const exceptionRefRIds: number[] = _.map(
                            exceptions,
                            (anException: WB_ModelingSessionRefRRow) => anException.cif.WB_MODELING_SESSION_REFR_ID
                        )

                        resolve(exceptions)
                    }
                } catch (e) {
                    self.ValidateMessageProvider.addMessage({
                        code: "ValidatePoliciesError",
                        type: MessageType.Error,
                        title: "Error in validating policies",
                        description: `${e}`,
                        subtitle: "",
                        count: 0
                    })
                    resolve([])
                    return
                }
            }

            executeValidatePolicies()
        })
    }

    async getAffinitySetCustomerProductPairs(options: any): Promise<{ WB_CUST_ID: number; WB_PRDGRP_ID: number }[]> {
        const self = this

        //Get the CannMR - Cannibalization Type Relationship rows
        const arrModelingSessionCannMRRows: WB_ModelingSessionCannMRRow[] = _.filter(
            self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows,
            (aRow: WB_ModelingSessionCannMRRow) => aRow.isActive
        )

        //Get the affinity sets from the CannMR relationships
        const arrAffinitySets: WB_AffinitySetRow[] = []
        _.forEach(arrModelingSessionCannMRRows, (aCMRRow: WB_ModelingSessionCannMRRow) => {
            _.forEach(aCMRRow.WB_ModelingSessionASRRows, (aASRRow: WB_ModelingSessionASRRow) => {
                if (aASRRow.isActive) {
                    arrAffinitySets.push(aASRRow.WB_AffinitySetRow)
                }
            })
        })

        const arrAFCustIds: { WB_CUST_ID: number }[] = []
        const arrAFProdIds: { WB_PRDGRP_ID: number }[] = []
        const dctCusts: number[] = []
        const dctProds: number[] = []

        for (const aAffSetRow of arrAffinitySets) {
            const arrAffSetGroups: WB_AffinityGroupRow[] = await self.dbContext.findAll(esWB_AffinityGroup, {
                where: {
                    WB_AFFINITYSET_ID: aAffSetRow.cif.WB_AFFINITYSET_ID,
                    DELETED_IND: {nin: ["1"]}
                }
            })
            for (const aAffSetGrpRow of arrAffSetGroups) {
                const arrAffSetItemRows: WB_AffinityGroupItemRow[] = await self.dbContext.findAll(
                    esWB_AffinityGroupItem,
                    {
                        where: {
                            WB_AFFINITYGROUP_ID: aAffSetGrpRow.cif.WB_AFFINITYGROUP_ID,
                            DELETED_IND: {nin: ["1"]}
                        }
                    }
                )
                _.forEach(arrAffSetItemRows, (aAffSetGrpItemRow: WB_AffinityGroupItemRow) => {
                    const custId: number = aAffSetGrpItemRow.cif.WB_CUST_ID
                    if (!(custId in dctCusts)) {
                        arrAFCustIds.push({
                            WB_CUST_ID: custId
                        })
                        dctCusts[custId] = custId
                    }

                    let prdGrpId: number = -1
                    if (aAffSetRow.bItemHasProduct) prdGrpId = aAffSetGrpItemRow.cif.WB_PROD_ID
                    else prdGrpId = aAffSetGrpItemRow.cif.WB_PRDGRP_ID

                    if (!(prdGrpId in dctProds)) {
                        arrAFProdIds.push({
                            WB_PRDGRP_ID: prdGrpId
                        })
                        dctProds[prdGrpId] = prdGrpId
                    }
                })
            }
        }

        const arrAffSetCustProdPairs: {
            WB_CUST_ID: number;
            WB_PRDGRP_ID: number;
        }[] = []

        _.forEach(arrAFCustIds, (aCust) => {
            _.forEach(arrAFProdIds, (aPrd) => {
                arrAffSetCustProdPairs.push({
                    WB_CUST_ID: aCust.WB_CUST_ID,
                    WB_PRDGRP_ID: aPrd.WB_PRDGRP_ID
                })
            })
        })

        return arrAffSetCustProdPairs
    }

    createOverrideRefRRows(arrWB_MODELING_SESSION_REFR_IDs: number[]): Promise<WB_ModelingSessionRefRRow[]> {
        const self = this
        return new Promise<WB_ModelingSessionRefRRow[]>((resolve, error) => {
            const arrKeyByRefRId = _.keyBy(arrWB_MODELING_SESSION_REFR_IDs, (a) => a)
            const overrideRefRRows: WB_ModelingSessionRefRRow[] = _.filter(
                self.WB_ModelingSession.WB_ModelingSessionRefRRows,
                (aRefRRow: WB_ModelingSessionRefRRow) => aRefRRow.cif.WB_MODELING_SESSION_REFR_ID in arrKeyByRefRId
            )

            _.forEach(overrideRefRRows, (aOvrdRefRRow: WB_ModelingSessionRefRRow) => {
                aOvrdRefRRow.cif.OVRD_IND = "1"
            })

            self.OnModelingSessionRefRCollectionChanged.next(self)
            resolve(overrideRefRRows)
        })
    }

    //</editor-fold>

    //<editor-fold desc="IHaveModelingSessionCalculator operations">

    private _solverProgressProvider: ProgressProvider
    private _solverMessageProvider: MessageProvider
    private _solverTrialsChanged: BehaviorSubject<ModelingSessionBO>

    private IModelingSessionSolver_init() {
        this._solverProgressProvider = new ProgressProvider("Solve")
        this._solverMessageProvider = new MessageProvider()
        this._solverTrialsChanged = new BehaviorSubject<ModelingSessionBO>(this)
    }

    get bInterceptModel(): boolean {
        const self = this
        const modelRow = self.WB_ModelingSession.WB_ModelRow
        const modelTerms: WB_ModelTermRow[] = _.map(
            _.filter(modelRow.WB_ModelTermRelationshipRows, (aRow: WB_ModelTermRelationshipRow) => aRow.isActive),
            (aRow) => aRow.WB_ModelTermRow
        )

        const interceptTerms = _.filter(
            modelTerms,
            (aTerm: WB_ModelTermRow) => aTerm.cif.TERM_TYPE.toLowerCase() == "intercept"
        )

        if (interceptTerms.length == 1) {
            const termModelFunction = interceptTerms[0].WB_ModelFunctionRow
            const coeffCount = termModelFunction.cif.COEFFICIENT_COUNT
            if (coeffCount == 1) {
                if (self.WB_ModelingSession.isActiveNew) self.drWB_ModelingSession.cif.INTELLIGENT_INTERCEPT = "1"
                return true
            } else {
                self.drWB_ModelingSession.cif.INTELLIGENT_INTERCEPT = "0"
                return false
            }
        } else {
            self.drWB_ModelingSession.cif.INTELLIGENT_INTERCEPT = "0"
            return false
        }
    }

    get SolverProgressProvider(): IProgressProvider {
        return this._solverProgressProvider
    }

    get SolverMessageProvider(): IMessageProvider {
        return this._solverMessageProvider
    }

    get SolverTrialsChanged(): BehaviorSubject<ModelingSessionBO> {
        return this._solverTrialsChanged
    }

    public async Solve(options: IModelingSessionServiceCalculateSessionOptions): Promise<void> {
        const self = this

        self.ValidateMessageProvider.clearMessages()
        // ModelingSessionBOValidations.ValidatePowerMetricWeight(self)
        //     .then((ignore) => {
        //         if(self.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
        //             self.ValidateProgressProvider.finish();
        //             return
        //         }
        //         }
        //     })
        self.SolverMessageProvider.clearMessages()
        self.SolverMessageProvider.addMessage({
            type: MessageType.Information,
            code: "Start",
            title: "Starting Model Solve",
            description: "Starting Model Solve"
        })
        const modelingSessionId: number = self.WB_ModelingSession.cif.WB_MODELING_SESSION_ID
        const modelService = new ModelingSessionService()

        try {
            // Don't check status, just run it
            self.SolverProgressProvider.start("Solving")

            const response: IModelingSessionServiceResponse = await modelService.CalculateSession(modelingSessionId, {
                SolveWithoutModelSessionMetricTags: options.SolveWithoutModelSessionMetricTags,
                SolveWithoutNoDataTags: options.SolveWithoutNoDataTags,
                RecalculateConstants: options.RecalculateConstants,
                CalculateIntelligentIntercept: options.CalculateIntelligentIntercept
            })

            if (!response?.isSuccess) {
                self.SolverProgressProvider.exception(response.errors)
                self._solverMessageProvider.addTextMessages("SolveError", MessageType.Error, response.errors)
            } else {
                self.SolverMessageProvider.addMessage({
                    type: MessageType.Information,
                    code: "Complete",
                    title: "Model Solve Complete",
                    description: "Model Solve Complete"
                })
                self.SolverProgressProvider.finish()
                self.SolverMessageProvider.addMessage({
                    code: "CalcMessage",
                    type: MessageType.Information,
                    title: JSON.stringify(response.results),
                    description: "",
                    subtitle: "",
                    count: 0
                })

                await self.Reload()
            }

            self.SolverTrialsChanged.next(self)
        } catch (e) {
            self.SolverProgressProvider.exception(e)
            self.SolverMessageProvider.addMessage({
                code: "CalcError",
                type: MessageType.Error,
                title: "Error in solving the modeling session",
                description: `${e}`,
                subtitle: "",
                count: 0
            })
            self.SolverTrialsChanged.next(self)
        } finally {
            if (!self.SolverProgressProvider.process_completed) self.SolverProgressProvider.finish()
        }
    }

    async purgeAuditTrail(refId: string, refType: string) {
        const self = this
        const createDt: Date = new Date()
        const aSplitDtTm = DateUtils.convertToSAPBWDateTimeSplit(createDt)
        let query: { [id: number | string]: any } = {
            WB_REFERENCE_ID: refId,
            WB_REFERENCE_TYPE: refType,
            DELETED_IND: {neq: "1"},
            CREATED_DT: {lte: aSplitDtTm?.Dt}
        }

        let findQuery: any = {where: query}
        let arrAuditLogRows = await self.dbContext.findAll(esWB_Audit_Log, findQuery)
        if (_.isEmpty(arrAuditLogRows)) {
            query = {
                WB_REFERENCE_ID: refId,
                WB_REFERENCE_TYPE: refType,
                DELETED_IND: {neq: "1"},
                CREATED_TM: {lte: aSplitDtTm.Tm},
                CREATED_DT: {lte: aSplitDtTm?.Dt}
            }
            findQuery = {where: query}
            arrAuditLogRows = await self.dbContext.findAll(esWB_Audit_Log, findQuery)
        }
        _.forEach(arrAuditLogRows, (aRow: WB_AuditLogRow) => {
            aRow.markDeleted()
        })
        let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
        saveFunction = self.dbContext.Save.bind(self.dbContext)
        const r = await saveFunction(esWB_Audit_Log, arrAuditLogRows)
        console.log("removed audit trail")
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveAffinitySets operations">

    private _bIHaveAffinitySetsLoaded: boolean
    private _OnIHaveAffinitySetsLoaded: Promise<IHaveAffinitySets>
    private _arrAffinitySets: WB_AffinitySetRow[]
    private _dctAffinitySets: { [wbAffinitySetOd: number]: WB_AffinitySetRow }
    private _arrAffinitySetsAll: WB_AffinitySetRow[]
    private _AffinitySetsChanged: BehaviorSubject<IHaveAffinitySets>

    private IHaveAffinitySets_init(): void {
        this._bIHaveAffinitySetsLoaded = false
        this._OnIHaveAffinitySetsLoaded = undefined
        this._arrAffinitySets = []
        this._dctAffinitySets = {}
        this._arrAffinitySetsAll = []
        this._AffinitySetsChanged = new BehaviorSubject<IHaveAffinitySets>(this)
    }

    // Run after BO.Load & LoadNew
    private async IHaveAffinitySets_OnLoadCompleted(): Promise<void> {
        const self = this
        await self.OnIHaveAffinitySetsLoaded
    }

    private async IHaveAffinitySets_setupAll(): Promise<void> {
        const self = this

        // Available Affinity Sets must match Cannibalization Types and Model *Customer and Product Level
        const dctWBCannTypesRow: { [id: number]: WB_ModelCannibalizationTypeRow } = {}
        _.forEach(self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows, (aRow) => {
            if (!aRow.isActive) return
            if (_.isEmpty(aRow.WB_ModelCannibalizationTypeRow)) return

            dctWBCannTypesRow[aRow.WB_ModelCannibalizationTypeRow.cif.WB_MODEL_CANNIBALIZATIONM_ID] =
                aRow.WB_ModelCannibalizationTypeRow
        })

        const arrWbCannibalizationMId = _.keys(dctWBCannTypesRow)
        const query: any = {
            DELETED_IND: {notIn: ["1"]},
            WB_MDSET_ID: self.drWB_ModelingSession.cif.WB_MDSET_ID,
            WB_SALESORG_ID: self.drWB_ModelingSession.cif.WB_SALESORG_ID,
            WB_MODEL_CANNIBALIZATIONM_ID: {inq: arrWbCannibalizationMId}
        }

        let arrAffinitySets: WB_AffinitySetRow[] = []
        const modelRow = self.Model.WB_Model

        if (!_.isEmpty(arrWbCannibalizationMId))
            arrAffinitySets = <WB_AffinitySetRow[]>await self.dbContext.findAll(esWB_AffinitySet, query)

        const allAffinitySets = _.filter(arrAffinitySets, (aRow) => {
            // Check the Level
            if (
                aRow.bItemHasCusotmer &&
                aRow.cif.WB_ENTITY_ID_CUSTOMER != self.drWB_ModelingSession.cif.WB_ENTITY_ID_CUSTOMER
            )
                return false

            //-- All affinity sets have product, check the level

            if (aRow.cif.WB_ENTITY_ID_PRODUCT != self.drWB_ModelingSession.cif.WB_ENTITY_ID_PRODUCT) return false

            return true
        })

        self._arrAffinitySetsAll = allAffinitySets
    }

    private IHaveAffinitySets_resetAffinitySetDict(): void {
        const self = this

        this._dctAffinitySets = {}
        this._arrAffinitySets = []
        _.forEach(self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows, (aCanTypeRow) => {
            if (!aCanTypeRow.isActive) return

            _.forEach(aCanTypeRow.WB_ModelingSessionASRRows, (aRow) => {
                if (!aRow.isActive) return
                if (_.isEmpty(aRow.WB_AffinitySetRow)) return

                const wbAffinitySetId = aRow.WB_AffinitySetRow.cif.WB_AFFINITYSET_ID
                if (!(wbAffinitySetId in this._dctAffinitySets)) {
                    this._dctAffinitySets[wbAffinitySetId] = aRow.WB_AffinitySetRow
                    this._arrAffinitySets.push(aRow.WB_AffinitySetRow)
                }
            })
        })
    }

    get bIHaveAffinitySetsLoaded(): boolean {
        return this._bIHaveAffinitySetsLoaded
    }

    get OnIHaveAffinitySetsLoaded(): Promise<IHaveAffinitySets> {
        const self = this
        if (self.bIHaveAffinitySetsLoaded) return Promise.resolve(self)

        if (!_.isEmpty(self._OnIHaveAffinitySetsLoaded)) return self._OnIHaveAffinitySetsLoaded

        const returnValue = (self._OnIHaveAffinitySetsLoaded = (async () => {
            await self.IHaveAffinitySets_setupAll()
            self.IHaveAffinitySets_resetAffinitySetDict()

            self._bIHaveAffinitySetsLoaded = true
            return self
        })())

        return returnValue
    }

    get AffinitySets(): WB_AffinitySetRow[] {
        return this._arrAffinitySets
    }

    get AffinitySetsChanged(): BehaviorSubject<IHaveAffinitySets> {
        return this._AffinitySetsChanged
    }

    get AllAffinitySets(): WB_AffinitySetRow[] {
        return this._arrAffinitySetsAll
    }

    get AffinitySetsReadOnly(): boolean {
        return false
    }

    isAffinitySetEditable(wbAffinitySetId: number): boolean {
        return true
    }

    hasAffinitySet(wbAffinitySetId: number): boolean {
        return wbAffinitySetId in this._dctAffinitySets
    }

    async addAffinitySet(wbAffinitySetId: number): Promise<void> {
        const self = this

        const affinitySetRow: WB_AffinitySetRow = <WB_AffinitySetRow>(
            await self.dbContext.find(esWB_AffinitySet, wbAffinitySetId)
        )

        if (_.isEmpty(affinitySetRow)) return

        //--
        let msCannTypeRow: WB_ModelingSessionCannMRRow = undefined
        _.forEach(self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows, (aRow) => {
            if (!aRow.isActive) return

            if (aRow.cif.WB_MODEL_CANNIBALIZATIONM_ID == affinitySetRow.cif.WB_MODEL_CANNIBALIZATIONM_ID) {
                msCannTypeRow = aRow
                return false
            }
        })

        if (_.isEmpty(msCannTypeRow)) return

        //-- Check if it already exists
        let bFound = false
        _.forEach(msCannTypeRow.WB_ModelingSessionASRRows, (aRow) => {
            if (!aRow.isActive) return

            if (aRow.cif.WB_AFFINITYSET_ID == affinitySetRow.cif.WB_AFFINITYSET_ID) bFound = true
        })

        if (bFound) return

        const aNewRow: WB_ModelingSessionASRRow = <WB_ModelingSessionASRRow>(
            await self.dbContext.createRecordWithKey(esWB_Modeling_Session_AffinitySet_Relationship)
        )
        aNewRow.cif.WB_MODELING_SESSION_CANNMR_ID = msCannTypeRow.cif.WB_MODELING_SESSION_CANNMR_ID
        aNewRow.WB_ModelingSessionCannMRRow = msCannTypeRow
        aNewRow.cif.WB_AFFINITYSET_ID = affinitySetRow.cif.WB_AFFINITYSET_ID
        aNewRow.WB_AffinitySetRow = affinitySetRow
        self.dbContext.add(esWB_Modeling_Session_AffinitySet_Relationship, aNewRow)

        self.IHaveAffinitySets_resetAffinitySetDict()

        self.AffinitySetsChanged.next(self)
    }

    async removeAffinitySet(wbAffinitySetId: number): Promise<void> {
        const self = this

        let bFound = false
        _.forEach(self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows, (aRow) => {
            if (!aRow.isActive) return

            _.forEach(aRow.WB_ModelingSessionASRRows, (aRelRow) => {
                if (!aRelRow.isActive) return

                if (aRelRow.cif.WB_AFFINITYSET_ID == wbAffinitySetId) {
                    bFound = true
                    aRelRow.markDeleted()
                }
            })
        })

        self.IHaveAffinitySets_resetAffinitySetDict()

        self.AffinitySetsChanged.next(self)
    }

    getStockPilingPeriods(wbAffinitySetId: number): number {
        const self = this

        let returnValue: number = 0

        _.forEach(self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows, (aCanRelRow) => {
            if (!aCanRelRow?.isActive) return

            _.forEach(aCanRelRow.WB_ModelingSessionASRRows, (aASRelRow) => {
                if (!aASRelRow?.isActive) return

                if (!aASRelRow.WB_AffinitySetRow) return

                if (aASRelRow.WB_AffinitySetRow.cif.WB_AFFINITYSET_ID == wbAffinitySetId) {
                    returnValue = aASRelRow.cif.STOCKPILING_PERIODS
                    return false
                }
            })
        })

        return returnValue
    }

    setStockPilingPeriods(wbAffinitySetId: number, iStockPilingWeeks: number): void {
        const self = this

        _.forEach(self.WB_ModelingSession.WB_ModelingSessionCannTypeRelRows, (aCanRelRow) => {
            if (!aCanRelRow?.isActive) return

            _.forEach(aCanRelRow.WB_ModelingSessionASRRows, (aASRelRow) => {
                if (!aASRelRow?.isActive) return

                if (!aASRelRow.WB_AffinitySetRow) return

                if (aASRelRow.WB_AffinitySetRow.cif.WB_AFFINITYSET_ID == wbAffinitySetId) {
                    aASRelRow.cif.STOCKPILING_PERIODS = iStockPilingWeeks
                }
            })
        })
    }

    private _dateRange: IDateRange = {}

    get dataDateRange(): IDateRange {
        return this._dateRange
    }

    async onDataScopeChanged(): Promise<void> {
        const self = this
        if (!self._bAllSourceCustomersLoaded) await self.OnIHaveSourceCustomersLoaded

        if (_.includes(["FinishedProduct", "ConsumerProduct"], self.drWB_ModelingSession.PRODUCT_LEVEL)) {
            if (!self._bIHaveFinishedProductsLoaded) await self.OnIHaveFinishedProductsLoaded
        } else {
            if (!self._bIHaveProductGroupsLoaded) await self.OnIHaveProductGroupsLoaded
        }

        const drDataSourceRow = self._loadedDataSourceICst
        if (_.isEmpty(drDataSourceRow)) return
        const entityName = drDataSourceRow.cif.TARGET_TABLENAME.replace("/AZR/", "")
        const startDate = self.WB_ModelingSession.SessionDate.Range.StartDt
        const endDate = self.WB_ModelingSession.SessionDate.Range.EndDt

        let arrCustKeys: number[] = []
        const wbCustIds = _.map(
            _.filter(self.drWB_ModelingSession.WB_ModelingSessionCustRRows, (row) => row.isActive),
            "WB_CUST_ID"
        )
        if (drDataSourceRow.cif.ENTITY_ID_CUSTOMER != self.drWB_ModelingSession.CUSTOMER_LEVEL) {
            for (const wbCstId of wbCustIds) {
                const wbCstIdChildren = await CustomerHierarchyService.getChildren(
                    self.drWB_ModelingSession.cif.WB_CUSTH_ID,
                    wbCstId,
                    startDate,
                    endDate,
                    drDataSourceRow.cif.ENTITY_ID_CUSTOMER
                )
                arrCustKeys = _.concat(arrCustKeys, wbCstIdChildren)
            }
        } else {
            arrCustKeys = wbCustIds
        }

        let arrPrdKeys: number[] = []
        const wbPrdIds = _.concat(
            _.map(
                _.filter(
                    self.drWB_ModelingSession.WB_ModelingSessionProdRRows,
                    (row) => row.isActive && row.cif.WB_PRDGRP_ID > 0
                ),
                "WB_PRDGRP_ID"
            ),
            _.map(
                _.filter(
                    self.drWB_ModelingSession.WB_ModelingSessionProdRRows,
                    (row) => row.isActive && row.cif.WB_PROD_ID > 0
                ),
                "WB_PROD_ID"
            )
        )
        if (drDataSourceRow.cif.ENTITY_ID_PRODUCT != self.drWB_ModelingSession.PRODUCT_LEVEL) {
            for (const wbPrdId of wbPrdIds) {
                const wbPrdIdChildren = await ProductHierarchyService.getChildren(
                    self.drWB_ModelingSession.cif.WB_PRDH_ID,
                    wbPrdId,
                    startDate,
                    endDate,
                    Product_Hierarchy_OrgLevel_Product
                )
                arrPrdKeys = _.concat(arrPrdKeys, wbPrdIdChildren)
            }
        } else {
            arrPrdKeys = wbPrdIds
        }

        const where: { [id: string]: any } = {}
        const fields: { [id: string]: any } = {}
        if (arrCustKeys.length > 0) {
            where[drDataSourceRow.cif.CUSTOMER_FIELDNAME] = {inq: arrCustKeys}
            fields[drDataSourceRow.cif.CUSTOMER_FIELDNAME] = {type: "int"}
        }

        if (arrPrdKeys.length > 0) {
            where[drDataSourceRow.cif.PRODUCT_FIELDNAME] = {inq: arrPrdKeys}
            fields[drDataSourceRow.cif.PRODUCT_FIELDNAME] = {type: "int"}
        }

        let distinct: string[] = []
        let order: string[] = []

        if (self._loadedDataSourceICst.cif.PERIOD_METHOD == "dateRange") {
            if (drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME != drDataSourceRow.cif.EFFECTIVE_END_DT_FIELDNAME) {
                distinct = [
                    drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME,
                    drDataSourceRow.cif.EFFECTIVE_END_DT_FIELDNAME
                ]
                order = [
                    drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME,
                    drDataSourceRow.cif.EFFECTIVE_END_DT_FIELDNAME
                ]
                fields[drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME] = {type: "string"}
                fields[drDataSourceRow.cif.EFFECTIVE_END_DT_FIELDNAME] = {type: "string"}
            } else {
                distinct = [drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME]
                order = [drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME]
                fields[drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME] = {type: "string"}
            }
        } else {
            distinct = [drDataSourceRow.cif.PERIOD_FIELDNAME]
            order = [drDataSourceRow.cif.PERIOD_FIELDNAME]
            fields[drDataSourceRow.cif.PERIOD_FIELDNAME] = {type: "int"}
        }

        const results = await PASearch.findByRequest({
            distinct: distinct,
            model: entityName,
            where: where,
            fields: fields,
            order: order
        })

        if (results.length) {
            if (distinct.length == 1) {
                const resultDates = _.map(results, drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME)
                // @ts-ignore
                self._dateRange.StartDt = DateUtils.convertFromSAPBWToReadable(_.first(resultDates), "us")
                // @ts-ignore
                self._dateRange.EndDt = DateUtils.convertFromSAPBWToReadable(_.last(resultDates), "us")
            } else {
                const dates = _.orderBy(
                    _.uniq(
                        _.concat(
                            _.map(results, drDataSourceRow.cif.EFFECTIVE_START_DT_FIELDNAME),
                            _.map(results, drDataSourceRow.cif.EFFECTIVE_END_DT_FIELDNAME)
                        )
                    )
                )

                // @ts-ignore
                self._dateRange.StartDt = DateUtils.convertFromSAPBWToReadable(_.first(dates), "us")
                // @ts-ignore
                self._dateRange.EndDt = DateUtils.convertFromSAPBWToReadable(_.last(dates), "us")
            }
        } else {
            // @ts-ignore
            self._dateRange.StartDt = "N/A"
            // @ts-ignore
            self._dateRange.EndDt = "N/A"
        }
    }

    // </editor-fold>
}

PAEnvironment.registerBusinessObjectClass(ModelingSessionBO, "ModelingSessionBO", "Modeling Session")
